// src/constants/AnnouncementAudience.ts
var ANNOUNCEMENT_AUDIENCES = {
  ALL_USERS: "all_users",
  SELECTED_USERS: "selected_users"
};

// src/constants/accessGuard.ts
var ACCESS_GUARD = {
  UNREGISTERED_COURSE_ACCESS: "unregisteredCourseAccess",
  UNREGISTERED_QA_ACCESS: "unregisteredQAAccess",
  UNREGISTERED_NEWS_ACCESS: "unregisteredNewsAccess",
  UNREGISTERED_ARTICLES_ACCESS: "unregisteredArticlesAccess"
};

// src/constants/activityLogs.ts
var ACTIVITY_LOG_ACTION_TYPES = {
  CREATE: "create",
  UPDATE: "update",
  BULK_COURSE_CATEGORY_UPDATE: "bulk_course_category_update",
  BULK_COURSE_STATUS_UPDATE: "bulk_course_status_update",
  DELETE: "delete",
  LOGIN: "login",
  LOGIN_FAILED: "login_failed",
  LOGOUT: "logout",
  ENROLL_COURSE: "enroll_course",
  UNENROLL_COURSE: "unenroll_course",
  START_COURSE: "start_course",
  GROUP_ASSIGNMENT: "group_assignment",
  USERS_IMPORT: "users_import",
  PUBLISH_EMAIL_TEMPLATE: "publish_email_template",
  SAVE_AUTOMATION_DRAFT: "save_automation_draft",
  SIMULATE_AUTOMATION: "simulate_automation",
  APPLY_AUTOMATION: "apply_automation",
  ENABLE_AUTOMATION: "enable_automation",
  DISABLE_AUTOMATION: "disable_automation",
  DUPLICATE_AUTOMATION: "duplicate_automation",
  ARCHIVE_AUTOMATION: "archive_automation",
  ARCHIVE_EMAIL_TEMPLATE: "archive_email_template",
  RESTORE_EMAIL_TEMPLATE: "restore_email_template",
  ADD_EMAIL_TEMPLATE_LANGUAGE: "add_email_template_language",
  REMOVE_EMAIL_TEMPLATE_LANGUAGE: "remove_email_template_language",
  SEND_PASSWORD_RESET_EMAIL: "send_password_reset_email",
  RESEND_PASSWORD_CREATION_EMAIL: "resend_password_creation_email",
  COMPLETE_LESSON: "complete_lesson",
  COMPLETE_COURSE: "complete_course",
  COMPLETE_CHAPTER: "complete_chapter",
  EXPIRE_CERTIFICATE: "expire_certificate",
  RESET_CERTIFICATE: "reset_certificate",
  VIEW_ANNOUNCEMENT: "view_announcement",
  ENROLL_LEARNING_PATH: "enroll_learning_path",
  START_LEARNING_PATH: "start_learning_path",
  COMPLETE_LEARNING_PATH: "complete_learning_path",
  PLAY_SCORM: "play_scorm",
  COMPLETE_SCORM: "complete_scorm"
};
var ACTIVITY_LOG_RESOURCE_TYPES = {
  USER: "user",
  COURSE: "course",
  CHAPTER: "chapter",
  LESSON: "lesson",
  ANNOUNCEMENT: "announcement",
  GROUP: "group",
  SETTINGS: "settings",
  INTEGRATION: "integration",
  CATEGORY: "category",
  QA: "qa",
  NEWS: "news",
  ARTICLE: "article",
  ARTICLE_SECTION: "articleSection",
  LIVE_TRAINING: "live_training",
  LEARNING_PATH: "learning_path",
  SCORM: "scorm",
  EMAIL_TEMPLATE: "email_template",
  AUTOMATION: "automation"
};
var ACTIVITY_LOG_RESOURCE_ACTION_TYPES = {
  [ACTIVITY_LOG_RESOURCE_TYPES.USER]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.LOGIN,
    ACTIVITY_LOG_ACTION_TYPES.LOGIN_FAILED,
    ACTIVITY_LOG_ACTION_TYPES.LOGOUT,
    ACTIVITY_LOG_ACTION_TYPES.USERS_IMPORT,
    ACTIVITY_LOG_ACTION_TYPES.SEND_PASSWORD_RESET_EMAIL,
    ACTIVITY_LOG_ACTION_TYPES.RESEND_PASSWORD_CREATION_EMAIL
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.COURSE]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.BULK_COURSE_CATEGORY_UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.BULK_COURSE_STATUS_UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.START_COURSE,
    ACTIVITY_LOG_ACTION_TYPES.COMPLETE_COURSE,
    ACTIVITY_LOG_ACTION_TYPES.ENROLL_COURSE,
    ACTIVITY_LOG_ACTION_TYPES.EXPIRE_CERTIFICATE,
    ACTIVITY_LOG_ACTION_TYPES.RESET_CERTIFICATE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.CHAPTER]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.COMPLETE_CHAPTER
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.LESSON]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.COMPLETE_LESSON
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.ANNOUNCEMENT]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.VIEW_ANNOUNCEMENT
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.GROUP]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.GROUP_ASSIGNMENT,
    ACTIVITY_LOG_ACTION_TYPES.ENROLL_COURSE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.SETTINGS]: [ACTIVITY_LOG_ACTION_TYPES.UPDATE],
  [ACTIVITY_LOG_RESOURCE_TYPES.INTEGRATION]: [ACTIVITY_LOG_ACTION_TYPES.UPDATE],
  [ACTIVITY_LOG_RESOURCE_TYPES.CATEGORY]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.QA]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.NEWS]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.ARTICLE]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.ARTICLE_SECTION]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.LIVE_TRAINING]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.LEARNING_PATH]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.ENROLL_LEARNING_PATH,
    ACTIVITY_LOG_ACTION_TYPES.START_LEARNING_PATH,
    ACTIVITY_LOG_ACTION_TYPES.COMPLETE_LEARNING_PATH
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.SCORM]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.PLAY_SCORM,
    ACTIVITY_LOG_ACTION_TYPES.COMPLETE_SCORM
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.EMAIL_TEMPLATE]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.PUBLISH_EMAIL_TEMPLATE,
    ACTIVITY_LOG_ACTION_TYPES.ARCHIVE_EMAIL_TEMPLATE,
    ACTIVITY_LOG_ACTION_TYPES.RESTORE_EMAIL_TEMPLATE,
    ACTIVITY_LOG_ACTION_TYPES.ADD_EMAIL_TEMPLATE_LANGUAGE,
    ACTIVITY_LOG_ACTION_TYPES.REMOVE_EMAIL_TEMPLATE_LANGUAGE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.AUTOMATION]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.SAVE_AUTOMATION_DRAFT,
    ACTIVITY_LOG_ACTION_TYPES.SIMULATE_AUTOMATION,
    ACTIVITY_LOG_ACTION_TYPES.APPLY_AUTOMATION,
    ACTIVITY_LOG_ACTION_TYPES.ENABLE_AUTOMATION,
    ACTIVITY_LOG_ACTION_TYPES.DISABLE_AUTOMATION,
    ACTIVITY_LOG_ACTION_TYPES.DUPLICATE_AUTOMATION,
    ACTIVITY_LOG_ACTION_TYPES.ARCHIVE_AUTOMATION,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ]
};

// src/constants/aiJudge.ts
var AI_JUDGE_MAX_CRITERION_SCORE = 5;
var AI_JUDGE_GENERATION_MODE = {
  CREATE: "create",
  IMPROVE: "improve",
  REPAIR: "repair"
};
var AI_JUDGE_GENERATION_STATUS = {
  DRAFTING: "drafting",
  EVALUATING: "evaluating",
  REVISING: "revising",
  AWAITING_REVISION: "awaiting_revision",
  COMPLETED: "completed",
  REQUIRES_REVIEW: "requires_review",
  FAILED: "failed",
  CANCELLED: "cancelled"
};
var AI_JUDGE_VALIDATION_SEVERITY = {
  ERROR: "error",
  WARNING: "warning"
};
var AI_JUDGE_VALIDATION_TARGET = {
  CONFIGURATION: "configuration",
  CRITERION: "criterion",
  SCORE_GUIDANCE: "scoreGuidance",
  BLOCKING_ERROR: "blockingError"
};
var AI_JUDGE_DRAFT_CHANGE_TYPE = {
  ADDED: "added",
  REMOVED: "removed",
  CHANGED: "changed"
};
var AI_JUDGE_DRAFT_CHANGE_FIELD = {
  TASK_GOAL: "taskGoal",
  PASSING_THRESHOLD_PERCENT: "passingThresholdPercent",
  CRITERION: "criterion",
  TITLE: "title",
  EXPECTED_BEHAVIOR: "expectedBehavior",
  MAX_SCORE: "maxScore",
  SCORE_GUIDANCE: "scoreGuidance",
  DESCRIPTION: "description",
  EXAMPLE: "example",
  BLOCKING_ERROR: "blockingError"
};
var AI_JUDGE_GENERATION_MAX_ATTEMPTS = 3;
var AI_JUDGE_CONFIGURATION_GENERATION_SOCKET_EVENTS = {
  PROGRESS: "ai-judge-configuration-generation:progress"
};

// src/constants/aiMentorAvatar.ts
var ALLOWED_AVATAR_IMAGE_TYPES = ["image/jpeg", "image/png", "image/svg+xml", "image/jpg"];
var ALLOWED_EXTENSIONS = ".jpeg,.png,.svg,.jpg";

// src/constants/aiMentorGeneration.ts
var AI_MENTOR_CONFIGURATION_GENERATION_MODE = {
  CREATE: "create",
  IMPROVE: "improve",
  REPAIR: "repair"
};
var AI_MENTOR_CONFIGURATION_GENERATION_STATUS = {
  DRAFTING: "drafting",
  EVALUATING: "evaluating",
  REVISING: "revising",
  AWAITING_REVISION: "awaiting_revision",
  COMPLETED: "completed",
  REQUIRES_REVIEW: "requires_review",
  FAILED: "failed",
  CANCELLED: "cancelled"
};
var AI_MENTOR_CONFIGURATION_VALIDATION_SEVERITY = {
  ERROR: "error",
  WARNING: "warning"
};
var AI_MENTOR_CONFIGURATION_FIELD = {
  TASK_GOAL: "taskGoal",
  EXPERTISE: "expertise",
  CONTENT_SCOPE: "contentScope",
  TEACHING_STYLE: "teachingStyle",
  FEEDBACK_GUIDANCE: "feedbackGuidance",
  SCENARIO: "scenario",
  AI_ROLE: "aiRole",
  LEARNER_ROLE: "learnerRole",
  CHARACTER_GOAL: "characterGoal",
  DIFFICULTY: "difficulty",
  FACTS_AND_CONSTRAINTS: "factsAndConstraints",
  OPENING_INSTRUCTION: "openingInstruction",
  ADDITIONAL_INSTRUCTIONS: "additionalInstructions"
};
var AI_MENTOR_CONFIGURATION_DRAFT_CHANGE_TYPE = {
  ADDED: "added",
  REMOVED: "removed",
  CHANGED: "changed"
};
var AI_MENTOR_CONFIGURATION_GENERATION_MAX_ATTEMPTS = 3;
var AI_MENTOR_CONFIGURATION_GENERATION_SOCKET_EVENTS = {
  PROGRESS: "ai-mentor-configuration-generation:progress"
};

// src/constants/aiMentorPractice.ts
var AI_MENTOR_PRACTICE_STATUSES = {
  QUEUED: "queued",
  PROCESSING: "processing",
  READY: "ready",
  FAILED: "failed"
};
var AI_MENTOR_PRACTICE_ERROR_CODES = {
  GENERATION_FAILED: "generation_failed",
  QUEUE_FAILED: "queue_failed"
};

// src/constants/aiMentorTypes.ts
var AI_MENTOR_TYPE = {
  TEACHER: "teacher",
  ROLEPLAY: "roleplay"
};
var DEFAULT_AI_MENTOR_TYPE = AI_MENTOR_TYPE.ROLEPLAY;
var AI_MENTOR_TEACHING_STYLE = {
  EXPLAIN_AND_PRACTICE: "explain_and_practice",
  GUIDED_DISCOVERY: "guided_discovery",
  SOCRATIC: "socratic"
};
var AI_MENTOR_ROLEPLAY_DIFFICULTY = {
  COOPERATIVE: "cooperative",
  REALISTIC: "realistic",
  CHALLENGING: "challenging"
};

// src/constants/aiMentorVoice.ts
var AI_MENTOR_VOICE_MODE = {
  PRESET: "preset",
  CUSTOM: "custom"
};
var AI_MENTOR_TTS_PRESET = {
  MALE: "male",
  FEMALE: "female"
};

// src/constants/aiThreads.ts
var AI_THREAD_STATUSES = {
  ACTIVE: "active",
  COMPLETED: "completed",
  ARCHIVED: "archived"
};
var AI_THREAD_TYPES = {
  PRACTICE: "practice",
  AI_MENTOR: "ai-mentor"
};

// src/constants/allowedAge.ts
var ALLOWED_AGE_LIMITS = [13, 16, null];

// src/constants/announcements.ts
var ANNOUNCEMENT_STATUSES = {
  SCHEDULED: "scheduled",
  PUBLISHED: "published"
};
var ANNOUNCEMENT_FEEDS = {
  ALL: "all",
  ADMIN_ANNOUNCEMENTS: "admin_announcements",
  SYSTEM: "system"
};
var ANNOUNCEMENT_SOURCE_TYPES = {
  MANUAL: "manual",
  LIVE_TRAINING: "live_training",
  COURSE_DUE_DATE_REMINDER: "course_due_date_reminder",
  COURSE_CHAT: "course_chat"
};
var ANNOUNCEMENT_EMAIL_TEMPLATES = {
  DEFAULT: "default",
  LIVE_TRAINING_REMINDER: "live_training_reminder",
  LIVE_TRAINING_STARTED: "live_training_started",
  LIVE_TRAINING_ENDED: "live_training_ended"
};

// src/constants/articlesSettings.ts
var ALLOWED_ARTICLES_SETTINGS = {
  ARTICLES_ENABLED: "articlesEnabled",
  UNREGISTERED_USER_ARTICLES_ACCESSIBILITY: "unregisteredUserArticlesAccessibility"
};

// src/constants/articlesTypes.ts
var ARTICLE_STATUS = {
  PUBLISHED: "published",
  DRAFT: "draft"
};

// src/constants/assessment.ts
var ASSESSMENT_QUESTION_TYPES = {
  SINGLE_CHOICE: "single_choice",
  MULTIPLE_CHOICE: "multiple_choice",
  TRUE_OR_FALSE: "true_or_false",
  PHOTO_QUESTION_SINGLE_CHOICE: "photo_question_single_choice",
  PHOTO_QUESTION_MULTIPLE_CHOICE: "photo_question_multiple_choice",
  FILL_IN_THE_BLANKS_TEXT: "fill_in_the_blanks_text",
  FILL_IN_THE_BLANKS_DND: "fill_in_the_blanks_dnd",
  BRIEF_RESPONSE: "brief_response",
  DETAILED_RESPONSE: "detailed_response",
  SCALE_1_5: "scale_1_5"
};
var ASSESSMENT_GRADING_MODES = {
  AUTOMATIC: "automatic",
  MANUAL: "manual",
  PARTICIPATION: "participation"
};
var ASSESSMENT_ATTEMPT_LIMIT_MODES = {
  NONE: "none",
  LIFETIME: "lifetime",
  COOLDOWN_WINDOW: "cooldown_window"
};
var ASSESSMENT_FEEDBACK_MODES = {
  FULL: "full",
  SCORE_ONLY: "score_only",
  NONE: "none"
};
var ASSESSMENT_TEXT_COMPARISON_MODES = {
  EXACT: "exact",
  NORMALIZED: "normalized"
};
var ASSESSMENT_ATTEMPT_SUBMISSION_STATUSES = {
  IN_PROGRESS: "in_progress",
  SUBMITTED: "submitted",
  CANCELLED: "cancelled"
};
var ASSESSMENT_ATTEMPT_GRADING_STATUSES = {
  NOT_STARTED: "not_started",
  PENDING: "pending",
  GRADED: "graded"
};
var ASSESSMENT_ANSWER_GRADING_STATUSES = {
  PENDING: "pending",
  GRADED: "graded"
};
var ASSESSMENT_ATTEMPT_RESULTS = {
  PENDING: "pending",
  PASSED: "passed",
  FAILED: "failed"
};
var LEARNER_PROGRESS_STATUSES = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  AWAITING_REVIEW: "awaiting_review",
  COMPLETED: "completed"
};

// src/constants/automations.ts
var AUTOMATION_STATUSES = {
  DRAFT: "draft",
  ENABLED: "enabled",
  DISABLED: "disabled",
  ARCHIVED: "archived"
};
var AUTOMATION_STEP_TYPES = {
  TRIGGER: "trigger",
  SEND_EMAIL: "send_email",
  CONDITION: "condition"
};
var AUTOMATION_MAPPING_TYPES = { EVENT_FIELD: "event_field", STATIC: "static" };
var AUTOMATION_EVENT_KINDS = {
  WELCOME: "welcome",
  PASSWORD_RECOVERY: "password_recovery",
  PASSWORD_REMINDER: "password_reminder",
  USER_INVITE: "user_invite",
  USER_FIRST_LOGIN: "user_first_login",
  USER_ASSIGNED_TO_COURSE: "user_assigned_to_course",
  USER_SHORT_INACTIVITY: "user_short_inactivity",
  USER_LONG_INACTIVITY: "user_long_inactivity",
  USER_FINISHED_CHAPTER: "user_finished_chapter",
  USER_FINISHED_COURSE: "user_finished_course",
  CERTIFICATE_EXPIRATION_WARNING: "certificate_expiration_warning",
  CERTIFICATE_EXPIRED: "certificate_expired",
  ADMIN_NEW_USER: "admin_new_user",
  ADMIN_FINISHED_COURSE: "admin_finished_course",
  ADMIN_OVERDUE_COURSES: "admin_overdue_courses",
  COURSE_DUE_DATE_REMINDER: "course_due_date_reminder",
  MAGIC_LINK: "magic_link",
  COURSE_CHAT_MENTION: "course_chat_mention",
  ANNOUNCEMENT: "announcement",
  LIVE_TRAINING_STARTED: "live_training_started",
  LIVE_TRAINING_REMINDER: "live_training_reminder",
  LIVE_TRAINING_ENDED: "live_training_ended"
};
var BUILT_IN_EMAIL_TEMPLATE_KEYS = {
  ASSIGNMENT_WITH_DEADLINE: "assignment_with_deadline",
  ASSIGNMENT_WITHOUT_DEADLINE: "assignment_without_deadline",
  COMPLETION_WITH_CERTIFICATE: "completion_with_certificate",
  COMPLETION_WITHOUT_CERTIFICATE: "completion_without_certificate",
  CERTIFICATE_MANUALLY_RESET: "certificate_manually_reset",
  CERTIFICATE_NATURALLY_EXPIRED: "certificate_naturally_expired",
  SHORT_INACTIVITY_COURSE: "short_inactivity_course",
  SHORT_INACTIVITY_PLATFORM: "short_inactivity_platform",
  LONG_INACTIVITY_COURSE: "long_inactivity_course",
  LONG_INACTIVITY_PLATFORM: "long_inactivity_platform",
  DEADLINE_TODAY: "deadline_today",
  DEADLINE_TOMORROW: "deadline_tomorrow",
  DEADLINE_UPCOMING: "deadline_upcoming",
  WELCOME: "welcome",
  PASSWORD_RECOVERY: "password_recovery",
  PASSWORD_REMINDER: "password_reminder",
  USER_INVITE: "user_invite",
  USER_FIRST_LOGIN: "user_first_login",
  USER_FINISHED_CHAPTER: "user_finished_chapter",
  CERTIFICATE_EXPIRATION_WARNING: "certificate_expiration_warning",
  ADMIN_NEW_USER: "admin_new_user",
  ADMIN_FINISHED_COURSE: "admin_finished_course",
  ADMIN_OVERDUE_COURSES: "admin_overdue_courses",
  MAGIC_LINK: "magic_link",
  COURSE_CHAT_MENTION: "course_chat_mention",
  ANNOUNCEMENT: "announcement",
  LIVE_TRAINING_STARTED: "live_training_started",
  LIVE_TRAINING_REMINDER: "live_training_reminder",
  LIVE_TRAINING_ENDED: "live_training_ended"
};
var AUTOMATION_RUN_STATUSES = {
  PENDING: "pending",
  PROCESSING: "processing",
  SUCCEEDED: "succeeded",
  WARNINGS: "warnings",
  FAILED: "failed",
  CANCELLED: "cancelled"
};
var AUTOMATION_EMAIL_DELIVERY_STATUSES = {
  PENDING: "pending",
  PROCESSING: "processing",
  RETRYING: "retrying",
  SKIPPED: "skipped",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
  CANCELLED: "cancelled"
};
var AUTOMATION_PLACEHOLDER_TYPES = {
  STRING: "string",
  NUMBER: "number",
  BOOLEAN: "boolean",
  URL: "url",
  LOCALIZED_STRING: "localized_string",
  COLLECTION: "collection"
};
var AUTOMATION_MAX_EMAIL_DELIVERY_ATTEMPTS = 3;
var AUTOMATION_RUN_RETENTION_DAYS = 90;
var AUTOMATION_RESERVED_BRANDING_PLACEHOLDER = "company_name";
var AUTOMATION_TEMPLATE_TYPES = { BUILTIN: "builtin", CUSTOM: "custom" };
var AUTOMATION_RECIPIENT_TYPES = {
  EVENT: "event",
  USER: "user",
  GROUP: "group",
  ROLE: "role",
  EVERYONE: "everyone"
};
var AUTOMATION_DEFINITION_KINDS = { DRAFT: "draft", APPLIED: "applied" };
var AUTOMATION_NODE_KINDS = {
  ACTION: "action",
  CONDITION: "condition",
  TRIGGER: "trigger"
};
var ACCOUNT_ACTION_KINDS = {
  CREATE_PASSWORD: "create_password",
  RESET_PASSWORD: "reset_password",
  SIGN_IN: "sign_in"
};
var AUTOMATION_FIELD_SENSITIVITIES = {
  ORDINARY: "ordinary",
  ACCOUNT_ACTION_LINK: "account_action_link"
};
var AUTOMATION_VALIDATION_ISSUE_CODES = {
  CROSS_AUTOMATION_REFERENCE: "cross_automation_reference",
  CYCLE: "cycle",
  DISCONNECTED_STEP: "disconnected_step",
  DUPLICATE_STEP_ID: "duplicate_step_id",
  FIELD_UNAVAILABLE_ON_BRANCH: "field_unavailable_on_branch",
  INVALID_CONDITION_BRANCHES: "invalid_condition_branches",
  INVALID_CONDITION_FIELD: "invalid_condition_field",
  INVALID_CONDITION_VALUE: "invalid_condition_value",
  INVALID_POSITION: "invalid_position",
  INVALID_ROOT: "invalid_root",
  INVALID_SAMPLE: "invalid_sample",
  INVALID_STEP_ID: "invalid_step_id",
  INVALID_SUCCESSOR: "invalid_successor",
  INVALID_TEMPLATE: "invalid_template",
  INVALID_TEMPLATE_MAPPING: "invalid_template_mapping",
  INVALID_TRIGGER_ROOT: "invalid_trigger_root",
  MAPPING_TYPE_MISMATCH: "mapping_type_mismatch",
  MISSING_ACCOUNT_ACTION: "missing_account_action",
  MISSING_ACTION: "missing_action",
  MISSING_CONDITION_FIELD: "missing_condition_field",
  MISSING_EVENT: "missing_event",
  MISSING_MAPPING: "missing_mapping",
  MISSING_PARENT: "missing_parent",
  MISSING_TEMPLATE: "missing_template",
  MISSING_TRIGGER: "missing_trigger",
  NON_ROOT_TRIGGER: "non_root_trigger",
  RESERVED_MAPPING: "reserved_mapping",
  SELF_PARENT: "self_parent",
  UNAVAILABLE_RECIPIENTS: "unavailable_recipients",
  UNAVAILABLE_TEMPLATE: "unavailable_template",
  UNKNOWN_EVENT_FIELD: "unknown_event_field",
  UNKNOWN_PLACEHOLDER: "unknown_placeholder",
  UNSAFE_ACCOUNT_ACTION_RECIPIENTS: "unsafe_account_action_recipients",
  UNSUPPORTED_STEP_TYPE: "unsupported_step_type"
};
var AUTOMATION_CONDITION_BRANCH_POSITIONS = { YES: 0, NO: 1 };

// src/constants/automationTriggers.ts
var getSampleValue = (dataType) => {
  if (dataType === AUTOMATION_PLACEHOLDER_TYPES.URL) return "https://example.invalid/example";
  if (dataType === AUTOMATION_PLACEHOLDER_TYPES.NUMBER) return 3;
  if (dataType === AUTOMATION_PLACEHOLDER_TYPES.BOOLEAN) return true;
  return "Example";
};
var variable = (key, labelKey, dataType = AUTOMATION_PLACEHOLDER_TYPES.STRING, sourceKey = key) => ({
  key,
  label: key.replace(/([A-Z])/g, " $1").replace(/^./, (character) => character.toUpperCase()),
  labelKey,
  dataType,
  sourceKey,
  sampleValue: getSampleValue(dataType),
  ...["reset_link", "create_password_link", "magic_link"].includes(sourceKey) ? { sensitivity: AUTOMATION_FIELD_SENSITIVITIES.ACCOUNT_ACTION_LINK } : {}
});
var AUTOMATION_TRIGGER_DEFINITIONS = [
  {
    type: AUTOMATION_EVENT_KINDS.WELCOME,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.userWelcome",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "platformUrl",
        "automationBuilder.variables.platformUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "courses_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.PASSWORD_RECOVERY,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.userPasswordReminder",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "resetPasswordLink",
        "automationBuilder.variables.resetPasswordLink",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "reset_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.PASSWORD_REMINDER,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.userPasswordReminder",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "resetPasswordLink",
        "automationBuilder.variables.resetPasswordLink",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "create_password_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.USER_INVITE,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.userInvited",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "inviteLink",
        "automationBuilder.variables.inviteLink",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "create_password_link"
      ),
      variable(
        "invitedByUserName",
        "automationBuilder.variables.invitedByUserName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "invited_by_user_name"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.USER_FIRST_LOGIN,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.userFirstLogin",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "loginDate",
        "automationBuilder.variables.loginDate",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "loginDate"
      ),
      variable(
        "platformUrl",
        "automationBuilder.variables.platformUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "courses_url"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.USER_ASSIGNED_TO_COURSE,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.usersAssignedToCourse",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "courseName",
        "automationBuilder.variables.courseName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "course_name"
      ),
      variable(
        "courseUrl",
        "automationBuilder.variables.courseUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "course_link"
      ),
      variable(
        "dueDate",
        "automationBuilder.variables.dueDate",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "formatted_course_due_date"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.USER_SHORT_INACTIVITY,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.usersShortInactivity",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "courseName",
        "automationBuilder.variables.courseName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "course_name"
      ),
      variable(
        "courseUrl",
        "automationBuilder.variables.courseUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "course_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.USER_LONG_INACTIVITY,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.usersLongInactivity",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "courseName",
        "automationBuilder.variables.courseName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "course_name"
      ),
      variable(
        "courseUrl",
        "automationBuilder.variables.courseUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "course_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.USER_FINISHED_CHAPTER,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.userChapterFinished",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "courseName",
        "automationBuilder.variables.courseName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "course_name"
      ),
      variable(
        "chapterName",
        "automationBuilder.variables.chapterName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "chapter_name"
      ),
      variable(
        "courseUrl",
        "automationBuilder.variables.courseUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "course_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.USER_FINISHED_COURSE,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.userCourseFinished",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "courseName",
        "automationBuilder.variables.courseName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "course_name"
      ),
      variable(
        "hasCertificate",
        "automationBuilder.variables.hasCertificate",
        AUTOMATION_PLACEHOLDER_TYPES.BOOLEAN,
        "has_certificate"
      ),
      variable(
        "courseUrl",
        "automationBuilder.variables.courseUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "course_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.CERTIFICATE_EXPIRATION_WARNING,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.certificateExpirationWarning",
    providedVariables: [
      variable(
        "courseName",
        "automationBuilder.variables.courseName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "course_name"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "expirationDate",
        "automationBuilder.variables.expirationDate",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "expires_at"
      ),
      variable(
        "courseUrl",
        "automationBuilder.variables.courseUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "course_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.CERTIFICATE_EXPIRED,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.certificateArchived",
    providedVariables: [
      variable(
        "courseName",
        "automationBuilder.variables.courseName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "course_name"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "courseUrl",
        "automationBuilder.variables.courseUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "course_link"
      ),
      variable(
        "archiveReason",
        "automationBuilder.variables.archiveReason",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "reason"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.ADMIN_NEW_USER,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.userRegistered",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.userFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.userLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "registrationDate",
        "automationBuilder.variables.registrationDate",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "registrationDate"
      ),
      variable(
        "profileLink",
        "automationBuilder.variables.profileLink",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "profile_link"
      ),
      variable(
        "userName",
        "automationBuilder.variables.userName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "user_name"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.ADMIN_FINISHED_COURSE,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.courseCompleted",
    providedVariables: [
      variable(
        "courseName",
        "automationBuilder.variables.courseName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "course_name"
      ),
      variable(
        "userName",
        "automationBuilder.variables.userName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "user_name"
      ),
      variable(
        "progressLink",
        "automationBuilder.variables.progressLink",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "progress_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.ADMIN_OVERDUE_COURSES,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.usersAssignedToCourse",
    providedVariables: [
      variable(
        "overdueCoursesSummary",
        "automationBuilder.variables.overdueCoursesSummary",
        AUTOMATION_PLACEHOLDER_TYPES.LOCALIZED_STRING,
        "overdue_courses_summary"
      ),
      variable(
        "platformUrl",
        "automationBuilder.variables.platformUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "courses_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.COURSE_DUE_DATE_REMINDER,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.courseDueDateReminder",
    providedVariables: [
      variable(
        "userEmail",
        "automationBuilder.variables.userEmail",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userEmail"
      ),
      variable(
        "courseName",
        "automationBuilder.variables.courseName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "course_name"
      ),
      variable(
        "dueDate",
        "automationBuilder.variables.dueDate",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "due_date"
      ),
      variable(
        "daysLeft",
        "automationBuilder.variables.daysLeft",
        AUTOMATION_PLACEHOLDER_TYPES.NUMBER,
        "days_before_due_date"
      ),
      variable(
        "courseUrl",
        "automationBuilder.variables.courseUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "course_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.MAGIC_LINK,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.userPasswordReminder",
    providedVariables: [
      variable(
        "magicLink",
        "automationBuilder.variables.magicLink",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "magic_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.COURSE_CHAT_MENTION,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.courseChatUserMentioned",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.mentionedFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.mentionedLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "authorFullName",
        "automationBuilder.variables.authorFullName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "authorFullName"
      ),
      variable(
        "courseName",
        "automationBuilder.variables.courseName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "course_name"
      ),
      variable(
        "messageContent",
        "automationBuilder.variables.messageContent",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "message"
      ),
      variable(
        "chatUrl",
        "automationBuilder.variables.chatUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "course_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.ANNOUNCEMENT,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.announcementPublished",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.recipientFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.recipientLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "announcementTitle",
        "automationBuilder.variables.announcementTitle",
        AUTOMATION_PLACEHOLDER_TYPES.LOCALIZED_STRING,
        "title"
      ),
      variable(
        "announcementContent",
        "automationBuilder.variables.announcementContent",
        AUTOMATION_PLACEHOLDER_TYPES.LOCALIZED_STRING,
        "content"
      ),
      variable(
        "announcementUrl",
        "automationBuilder.variables.announcementUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "button_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.LIVE_TRAINING_STARTED,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.announcementPublished",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.recipientFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.recipientLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "announcementTitle",
        "automationBuilder.variables.announcementTitle",
        AUTOMATION_PLACEHOLDER_TYPES.LOCALIZED_STRING,
        "title"
      ),
      variable(
        "announcementContent",
        "automationBuilder.variables.announcementContent",
        AUTOMATION_PLACEHOLDER_TYPES.LOCALIZED_STRING,
        "content"
      ),
      variable(
        "announcementUrl",
        "automationBuilder.variables.announcementUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "live_training_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.LIVE_TRAINING_REMINDER,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.announcementPublished",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.recipientFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.recipientLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "announcementTitle",
        "automationBuilder.variables.announcementTitle",
        AUTOMATION_PLACEHOLDER_TYPES.LOCALIZED_STRING,
        "title"
      ),
      variable(
        "announcementContent",
        "automationBuilder.variables.announcementContent",
        AUTOMATION_PLACEHOLDER_TYPES.LOCALIZED_STRING,
        "content"
      ),
      variable(
        "announcementUrl",
        "automationBuilder.variables.announcementUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "live_training_link"
      )
    ]
  },
  {
    type: AUTOMATION_EVENT_KINDS.LIVE_TRAINING_ENDED,
    kind: AUTOMATION_NODE_KINDS.TRIGGER,
    labelKey: "automationBuilder.blocks.announcementPublished",
    providedVariables: [
      variable(
        "userFirstName",
        "automationBuilder.variables.recipientFirstName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userFirstName"
      ),
      variable(
        "userLastName",
        "automationBuilder.variables.recipientLastName",
        AUTOMATION_PLACEHOLDER_TYPES.STRING,
        "userLastName"
      ),
      variable(
        "announcementTitle",
        "automationBuilder.variables.announcementTitle",
        AUTOMATION_PLACEHOLDER_TYPES.LOCALIZED_STRING,
        "title"
      ),
      variable(
        "announcementContent",
        "automationBuilder.variables.announcementContent",
        AUTOMATION_PLACEHOLDER_TYPES.LOCALIZED_STRING,
        "content"
      ),
      variable(
        "announcementUrl",
        "automationBuilder.variables.announcementUrl",
        AUTOMATION_PLACEHOLDER_TYPES.URL,
        "live_training_link"
      )
    ]
  }
];
var getAutomationTriggerDefinition = (type) => AUTOMATION_TRIGGER_DEFINITIONS.find((definition) => definition.type === type);

// src/constants/automationEventVariables.ts
var snakeCase = (value) => value.replace(/([a-z0-9])([A-Z])/g, "$1_$2").toLowerCase();
var publicNames = {
  courses_url: "courses_link",
  reset_link: "reset_password_link",
  formatted_course_due_date: "course_due_date",
  due_date: "course_due_date",
  expires_at: "certificate_expiration_date",
  progress_link: "course_progress_link",
  days_before_due_date: "days_until_deadline",
  magic_link: "sign_in_link"
};
var liveTrainingEvents = [
  AUTOMATION_EVENT_KINDS.LIVE_TRAINING_STARTED,
  AUTOMATION_EVENT_KINDS.LIVE_TRAINING_REMINDER,
  AUTOMATION_EVENT_KINDS.LIVE_TRAINING_ENDED
];
var extra = (key, sourceKey, dataType, label, labelKey) => ({
  key,
  sourceKey,
  dataType,
  label,
  labelKey: `automationBuilder.variables.${labelKey}`,
  sampleValue: dataType === AUTOMATION_PLACEHOLDER_TYPES.BOOLEAN ? true : "https://example.invalid/example"
});
var AUTOMATION_EVENT_VARIABLES = Object.fromEntries(
  AUTOMATION_TRIGGER_DEFINITIONS.map((trigger) => {
    const variables = trigger.providedVariables.flatMap(
      (variable2) => {
        const source = variable2.sourceKey ?? variable2.key;
        if (trigger.type === AUTOMATION_EVENT_KINDS.CERTIFICATE_EXPIRED && source === "reason") return [];
        let key = publicNames[source] ?? snakeCase(source);
        let labelKey = variable2.labelKey;
        let label = variable2.label;
        if (source === "title" || source === "content") {
          key = `announcement_${source}`;
          if (liveTrainingEvents.includes(trigger.type)) {
            key = `live_training_${source}`;
            labelKey = `automationBuilder.variables.${key}`;
            label = source === "title" ? "Live training title" : "Live training message";
          }
        }
        if (trigger.type === AUTOMATION_EVENT_KINDS.ANNOUNCEMENT && source === "button_link")
          key = "announcement_link";
        if (source === "live_training_link") {
          labelKey = "automationBuilder.variables.live_training_link";
          label = "Live training link";
        }
        if (trigger.type === AUTOMATION_EVENT_KINDS.COURSE_CHAT_MENTION && source === "course_link")
          key = "discussion_link";
        if (trigger.type === AUTOMATION_EVENT_KINDS.COURSE_CHAT_MENTION && source === "message")
          key = "message_content";
        if (source === "create_password_link") {
          labelKey = "automationBuilder.variables.create_password_link";
          label = "Create password link";
        }
        return [{ ...variable2, key, sourceKey: source, labelKey, label }];
      }
    );
    switch (trigger.type) {
      case AUTOMATION_EVENT_KINDS.USER_ASSIGNED_TO_COURSE:
        variables.push(
          extra("has_deadline", "has_deadline", AUTOMATION_PLACEHOLDER_TYPES.BOOLEAN, "Has a deadline", "has_deadline")
        );
        break;
      case AUTOMATION_EVENT_KINDS.USER_FINISHED_COURSE:
        variables.push(
          extra(
            "certificate_link",
            "certificate_link",
            AUTOMATION_PLACEHOLDER_TYPES.URL,
            "Certificate link",
            "certificate_link"
          ),
          extra("courses_link", "courses_link", AUTOMATION_PLACEHOLDER_TYPES.URL, "Browse courses link", "courses_link")
        );
        break;
      case AUTOMATION_EVENT_KINDS.USER_SHORT_INACTIVITY:
      case AUTOMATION_EVENT_KINDS.USER_LONG_INACTIVITY:
        variables.push(
          extra("has_course", "has_course", AUTOMATION_PLACEHOLDER_TYPES.BOOLEAN, "Related to a course", "has_course"),
          extra("platform_link", "platform_link", AUTOMATION_PLACEHOLDER_TYPES.URL, "Platform link", "platform_link")
        );
        break;
      case AUTOMATION_EVENT_KINDS.CERTIFICATE_EXPIRED:
        variables.push(
          extra(
            "was_manually_reset",
            "was_manually_reset",
            AUTOMATION_PLACEHOLDER_TYPES.BOOLEAN,
            "Reset by an administrator",
            "was_manually_reset"
          )
        );
        break;
      case AUTOMATION_EVENT_KINDS.COURSE_DUE_DATE_REMINDER:
        variables.push(
          extra("is_due_today", "is_due_today", AUTOMATION_PLACEHOLDER_TYPES.BOOLEAN, "Due today", "is_due_today"),
          extra(
            "is_due_tomorrow",
            "is_due_tomorrow",
            AUTOMATION_PLACEHOLDER_TYPES.BOOLEAN,
            "Due tomorrow",
            "is_due_tomorrow"
          )
        );
        break;
    }
    if (trigger.type === AUTOMATION_EVENT_KINDS.PASSWORD_RECOVERY || trigger.type === AUTOMATION_EVENT_KINDS.USER_FIRST_LOGIN) {
      variables.push({
        key: "user_name",
        sourceKey: "name",
        dataType: AUTOMATION_PLACEHOLDER_TYPES.STRING,
        label: "Full name",
        labelKey: "automationBuilder.variables.userName",
        sampleValue: ""
      });
    }
    const identityVariables = [
      {
        key: "user_first_name",
        sourceKey: "userFirstName",
        label: "First name",
        labelKey: "automationBuilder.variables.userFirstName",
        dataType: AUTOMATION_PLACEHOLDER_TYPES.STRING,
        sampleValue: "Alex"
      },
      {
        key: "user_last_name",
        sourceKey: "userLastName",
        label: "Last name",
        labelKey: "automationBuilder.variables.userLastName",
        dataType: AUTOMATION_PLACEHOLDER_TYPES.STRING,
        sampleValue: "Morgan"
      },
      {
        key: "user_email",
        sourceKey: "userEmail",
        label: "Email address",
        labelKey: "automationBuilder.variables.userEmail",
        dataType: AUTOMATION_PLACEHOLDER_TYPES.STRING,
        sampleValue: "alex@example.invalid"
      }
    ];
    return [
      trigger.type,
      [
        ...identityVariables,
        ...variables.filter(
          (variable2) => !identityVariables.some((identity) => identity.key === variable2.key)
        )
      ]
    ];
  })
);
function resolveAutomationEventFieldSourceKey(kind, key) {
  return AUTOMATION_EVENT_VARIABLES[kind].find((variable2) => variable2.key === key)?.sourceKey ?? AUTOMATION_TRIGGER_DEFINITIONS.find((trigger) => trigger.type === kind)?.providedVariables.find(
    (variable2) => variable2.key === key
  )?.sourceKey ?? key;
}

// src/constants/certificate.ts
var SHARE_IMAGE_WIDTH = 1200;
var SHARE_IMAGE_HEIGHT = Math.round(SHARE_IMAGE_WIDTH * 210 / 297);
var CERTIFICATE_STATUSES = {
  ACTIVE: "active",
  ARCHIVED: "archived"
};
var COURSE_CERTIFICATE_STATUSES = {
  NOT_EARNED: "not_earned",
  ACTIVE: "active",
  EXPIRED: "expired",
  REVOKED: "revoked"
};
var CERTIFICATE_ARCHIVE_REASONS = {
  EXPIRED: "expired",
  MANUAL_RESET: "manual_reset"
};
var CERTIFICATE_VALIDITY_TYPES = {
  PERIOD: "period",
  FIXED_DATE: "fixedDate"
};
var CERTIFICATE_VALIDITY_UNITS = {
  DAYS: "days",
  MONTHS: "months",
  YEARS: "years"
};
var CERTIFICATE_RESET_SCOPES = {
  ALL: "all",
  GROUPS: "groups",
  USERS: "users"
};

// src/constants/automationEmailBranches.ts
var AUTOMATION_EMAIL_BRANCH_PLANS = {
  [AUTOMATION_EVENT_KINDS.USER_ASSIGNED_TO_COURSE]: {
    field: "has_deadline",
    yes: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.ASSIGNMENT_WITH_DEADLINE },
    no: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.ASSIGNMENT_WITHOUT_DEADLINE }
  },
  [AUTOMATION_EVENT_KINDS.USER_FINISHED_COURSE]: {
    field: "has_certificate",
    yes: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.COMPLETION_WITH_CERTIFICATE },
    no: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.COMPLETION_WITHOUT_CERTIFICATE }
  },
  [AUTOMATION_EVENT_KINDS.CERTIFICATE_EXPIRED]: {
    field: "was_manually_reset",
    yes: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.CERTIFICATE_MANUALLY_RESET },
    no: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.CERTIFICATE_NATURALLY_EXPIRED }
  },
  [AUTOMATION_EVENT_KINDS.USER_SHORT_INACTIVITY]: {
    field: "has_course",
    yes: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.SHORT_INACTIVITY_COURSE },
    no: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.SHORT_INACTIVITY_PLATFORM }
  },
  [AUTOMATION_EVENT_KINDS.USER_LONG_INACTIVITY]: {
    field: "has_course",
    yes: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.LONG_INACTIVITY_COURSE },
    no: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.LONG_INACTIVITY_PLATFORM }
  },
  [AUTOMATION_EVENT_KINDS.COURSE_DUE_DATE_REMINDER]: {
    field: "is_due_today",
    yes: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.DEADLINE_TODAY },
    no: {
      field: "is_due_tomorrow",
      yes: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.DEADLINE_TOMORROW },
      no: { templateKey: BUILT_IN_EMAIL_TEMPLATE_KEYS.DEADLINE_UPCOMING }
    }
  }
};
var AUTOMATION_BRANCH_FIELD_AVAILABILITY = {
  [AUTOMATION_EVENT_KINDS.USER_ASSIGNED_TO_COURSE]: {
    formatted_course_due_date: { field: "has_deadline", equals: true }
  },
  [AUTOMATION_EVENT_KINDS.USER_FINISHED_COURSE]: {
    certificate_link: { field: "has_certificate", equals: true },
    courses_link: { field: "has_certificate", equals: false }
  },
  [AUTOMATION_EVENT_KINDS.USER_SHORT_INACTIVITY]: {
    course_name: { field: "has_course", equals: true },
    course_link: { field: "has_course", equals: true },
    platform_link: { field: "has_course", equals: false }
  },
  [AUTOMATION_EVENT_KINDS.USER_LONG_INACTIVITY]: {
    course_name: { field: "has_course", equals: true },
    course_link: { field: "has_course", equals: true },
    platform_link: { field: "has_course", equals: false }
  }
};
function deriveAutomationBranchFieldValues(kind, fields) {
  const result = {};
  if (kind === AUTOMATION_EVENT_KINDS.USER_ASSIGNED_TO_COURSE)
    result.has_deadline = typeof fields.formatted_course_due_date === "string" && fields.formatted_course_due_date.trim().length > 0;
  if (kind === AUTOMATION_EVENT_KINDS.USER_FINISHED_COURSE && typeof fields.has_certificate === "boolean") {
    result[fields.has_certificate ? "certificate_link" : "courses_link"] = fields.button_link ?? "";
  }
  if (kind === AUTOMATION_EVENT_KINDS.USER_SHORT_INACTIVITY || kind === AUTOMATION_EVENT_KINDS.USER_LONG_INACTIVITY) {
    result.has_course = typeof fields.course_name === "string" && fields.course_name.trim().length > 0;
    if (!result.has_course) result.platform_link = fields.course_link ?? "";
  }
  if (kind === AUTOMATION_EVENT_KINDS.CERTIFICATE_EXPIRED && (fields.reason === CERTIFICATE_ARCHIVE_REASONS.MANUAL_RESET || fields.reason === CERTIFICATE_ARCHIVE_REASONS.EXPIRED))
    result.was_manually_reset = fields.reason === CERTIFICATE_ARCHIVE_REASONS.MANUAL_RESET;
  if (kind === AUTOMATION_EVENT_KINDS.COURSE_DUE_DATE_REMINDER && typeof fields.days_before_due_date === "number") {
    result.is_due_today = fields.days_before_due_date === 0;
    result.is_due_tomorrow = fields.days_before_due_date === 1;
  }
  return result;
}
function getCanonicalAutomationField(event, field) {
  return resolveAutomationEventFieldSourceKey(event.kind, field);
}

// src/constants/calendar.ts
var CALENDAR_EVENT_SOURCE_TYPES = {
  LIVE_TRAINING: "live_training",
  COURSE_DUE_DATE: "course_due_date",
  MICROSOFT_OUTLOOK: "microsoft_outlook"
};
var CALENDAR_PROVIDERS = {
  MICROSOFT: "microsoft"
};
var MICROSOFT_CALENDAR_OAUTH_RESULTS = {
  CONNECTED: "connected",
  REPLACEMENT_REQUIRED: "replacement_required",
  AUTHORIZATION_FAILED: "authorization_failed",
  ADMIN_APPROVAL_REQUIRED: "admin_approval_required"
};
var CALENDAR_EVENT_SOURCE_ROLES = {
  ADMIN: "admin",
  AUTHOR: "author",
  TRAINER: "trainer",
  OBSERVER: "observer"
};
var MICROSOFT_CALENDAR_CONNECTION_STATUSES = {
  SYNCING: "syncing",
  CONNECTED: "connected",
  ERROR: "error",
  RECONNECT_REQUIRED: "reconnect_required"
};
var MICROSOFT_CALENDAR_OUTBOUND_STATUSES = {
  DISABLED: "disabled",
  QUEUED: "queued",
  SYNCING: "syncing",
  CONNECTED: "connected",
  ERROR: "error"
};
var MICROSOFT_CALENDAR_PUBLIC_STATUSES = {
  DISCONNECTED: "disconnected",
  ...MICROSOFT_CALENDAR_CONNECTION_STATUSES
};
var OUTLOOK_EVENT_AVAILABILITIES = {
  FREE: "free",
  TENTATIVE: "tentative",
  BUSY: "busy",
  OUT_OF_OFFICE: "out_of_office",
  WORKING_ELSEWHERE: "working_elsewhere"
};
var OUTLOOK_EVENT_SENSITIVITIES = {
  NORMAL: "normal",
  PERSONAL: "personal",
  PRIVATE: "private",
  CONFIDENTIAL: "confidential"
};

// src/constants/contentMarketplace.ts
var CONTENT_MARKETPLACE_SORT = {
  RECENT: "recent",
  TITLE: "title"
};
var CONTENT_MARKETPLACE_DURATIONS = {
  SHORT: "short",
  MEDIUM: "medium",
  LONG: "long"
};

// src/constants/course.ts
var MAX_COURSE_LEARNING_OUTCOMES = 5;
var MAX_COURSE_TRAILER_VIDEO_SIZE_MB = 50;
var MAX_COURSE_TRAILER_VIDEO_SIZE = MAX_COURSE_TRAILER_VIDEO_SIZE_MB * 1024 * 1024;
var COURSE_STATUSES = {
  DRAFT: "draft",
  PUBLISHED: "published",
  PRIVATE: "private"
};
var COURSE_ARCHIVED_QUERY_VALUES = {
  TRUE: "true",
  FALSE: "false",
  ALL: "all"
};
var COURSE_PROGRESS_STATUSES = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  BLOCKED: "blocked"
};
var COURSE_TYPE = {
  DEFAULT: "default",
  SCORM: "scorm"
};
var COURSE_FEATURE = {
  CURRICULUM_EDITING: "curriculum_editing",
  LESSON_SEQUENCE_SETTING: "lesson_sequence_setting",
  QUIZ_FEEDBACK_SETTING: "quiz_feedback_setting",
  VIDEO_COMPLETION_TRACKING_SETTING: "video_completion_tracking_setting"
};
var COURSE_FEATURE_ERROR_TRANSLATION_KEY = {
  [COURSE_FEATURE.CURRICULUM_EDITING]: "adminCourseView.errors.featureUnavailable.curriculum",
  [COURSE_FEATURE.LESSON_SEQUENCE_SETTING]: "adminCourseView.errors.featureUnavailable.lessonSequence",
  [COURSE_FEATURE.QUIZ_FEEDBACK_SETTING]: "adminCourseView.errors.featureUnavailable.quizFeedback",
  [COURSE_FEATURE.VIDEO_COMPLETION_TRACKING_SETTING]: "adminCourseView.errors.featureUnavailable.videoCompletionTracking"
};
var COURSE_TYPE_DISABLED_FEATURES = {
  [COURSE_TYPE.DEFAULT]: [],
  [COURSE_TYPE.SCORM]: [
    COURSE_FEATURE.CURRICULUM_EDITING,
    COURSE_FEATURE.LESSON_SEQUENCE_SETTING,
    COURSE_FEATURE.QUIZ_FEEDBACK_SETTING,
    COURSE_FEATURE.VIDEO_COMPLETION_TRACKING_SETTING
  ]
};
var isCourseFeatureEnabledForCourseType = (courseType, feature) => {
  const disabledFeatures = COURSE_TYPE_DISABLED_FEATURES[courseType];
  return !disabledFeatures.includes(feature);
};

// src/constants/courseChat.ts
var COURSE_CHAT_SOCKET_EVENTS = {
  JOIN: "join:course-chat",
  LEAVE: "leave:course-chat",
  MESSAGE_CREATED: "course-chat:message-created",
  USER_PRESENCE_CHANGED: "course-chat:user-presence-changed",
  USER_MENTIONED: "course-chat:user-mentioned",
  MESSAGE_REACTIONS_UPDATED: "course-chat:message-reactions-updated",
  MESSAGE_DELETED: "course-chat:message-deleted"
};
var COURSE_CHAT_ALLOWED_REACTIONS = ["\u{1F44D}", "\u2764\uFE0F", "\u{1F602}", "\u{1F389}", "\u{1F62E}"];
var getCourseChatRoom = (courseId) => `course-chat:${courseId}`;

// src/constants/courseDuplication.ts
var COURSE_DUPLICATION_STATUS = {
  PROCESSING: "processing",
  COMPLETED: "completed",
  FAILED: "failed"
};
var COURSE_DUPLICATION_SOCKET = {
  EVENTS: {
    STATUS_CHANGED: "course-duplication-status-change"
  },
  MESSAGE_KEYS: {
    PROCESSING: "adminCourseDuplication.processing",
    COMPLETED: "adminCourseDuplication.completed",
    FAILED: "adminCourseDuplication.failed"
  }
};

// src/constants/courseEnrollment.ts
var COURSE_ENROLLMENT = {
  ENROLLED: "enrolled",
  NOT_ENROLLED: "not_enrolled",
  GROUP_ENROLLED: "group_enrolled"
};

// src/constants/features.ts
var FEATURES = {
  QA: "qa",
  NEWS: "news",
  ARTICLES: "articles",
  MODERN_COURSE_LIST: "modern_course_list",
  CALENDAR: "calendar",
  LIVE_TRAINING: "live_training",
  COURSE_DISCUSSIONS: "course_discussions"
};
var FEATURE_SETTINGS_KEYS = {
  [FEATURES.QA]: "QAEnabled",
  [FEATURES.NEWS]: "newsEnabled",
  [FEATURES.ARTICLES]: "articlesEnabled",
  [FEATURES.MODERN_COURSE_LIST]: "modernCourseListEnabled",
  [FEATURES.CALENDAR]: "calendarEnabled",
  [FEATURES.LIVE_TRAINING]: "liveTrainingEnabled",
  [FEATURES.COURSE_DISCUSSIONS]: "courseDiscussionsEnabled"
};
var FEATURE_UNREGISTERED_ACCESS_KEYS = {
  [FEATURES.NEWS]: "unregisteredUserNewsAccessibility",
  [FEATURES.ARTICLES]: "unregisteredUserArticlesAccessibility",
  [FEATURES.QA]: "unregisteredUserQAAccessibility"
};

// src/constants/permissions.ts
var SYSTEM_ROLE_SLUGS = {
  ADMIN: "admin",
  STUDENT: "student",
  CONTENT_CREATOR: "content_creator",
  TRAINER: "trainer",
  GROUP_MANAGER: "group_manager"
};
var PERMISSIONS = {
  PHISHING_MANAGE: "phishing.manage",
  PHISHING_REPORT_READ: "phishing.report_read",
  CONTENT_MARKETPLACE_BROWSE: "content_marketplace.browse",
  ACCOUNT_READ_SELF: "account.read_self",
  ACCOUNT_UPDATE_SELF: "account.update_self",
  USER_READ_SELF: "user.read_self",
  USER_MANAGE: "user.manage",
  SETTINGS_READ_SELF: "settings.read_self",
  SETTINGS_UPDATE_SELF: "settings.update_self",
  SETTINGS_MANAGE: "settings.manage",
  EMAIL_TEMPLATE_MANAGE: "email_template.manage",
  AUTOMATION_MANAGE: "automation.manage",
  AUTOMATION_LOG_READ: "automation_log.read",
  ENV_READ_PUBLIC: "env.read_public",
  ENV_MANAGE: "env.manage",
  CATEGORY_READ: "category.read",
  CATEGORY_MANAGE: "category.manage",
  GROUP_READ: "group.read",
  GROUP_MANAGE: "group.manage",
  MANAGED_GROUP_RESULTS_READ: "managed_group_results.read",
  LEARNING_PATH_READ: "learning_path.read",
  LEARNING_PATH_CREATE: "learning_path.create",
  LEARNING_PATH_UPDATE: "learning_path.update",
  LEARNING_PATH_UPDATE_OWN: "learning_path.update_own",
  LEARNING_PATH_DELETE: "learning_path.delete",
  LEARNING_PATH_COURSE_UPDATE: "learning_path.course_update",
  LEARNING_PATH_COURSE_UPDATE_OWN: "learning_path.course_update_own",
  LEARNING_PATH_ENROLLMENT: "learning_path.enrollment",
  LEARNING_PATH_EXPORT: "learning_path.export",
  CALENDAR_READ: "calendar.read",
  LIVE_TRAINING_READ: "live_training.read",
  LIVE_TRAINING_CREATE: "live_training.create",
  LIVE_TRAINING_UPDATE: "live_training.update",
  LIVE_TRAINING_UPDATE_OWN: "live_training.update_own",
  LIVE_TRAINING_DELETE: "live_training.delete",
  LIVE_TRAINING_DELETE_OWN: "live_training.delete_own",
  LIVE_TRAINING_JOIN: "live_training.join",
  LIVE_TRAINING_START: "live_training.start",
  LIVE_TRAINING_END: "live_training.end",
  LIVE_TRAINING_STATISTICS: "live_training.statistics",
  DASHBOARD_READ: "dashboard.read",
  TODO_TASK_MANAGE_SELF: "todo_task.manage_self",
  COURSE_READ_ASSIGNED: "course.read_assigned",
  COURSE_READ_MANAGEABLE: "course.read_manageable",
  COURSE_READ: "course.read",
  COURSE_CREATE: "course.create",
  COURSE_UPDATE: "course.update",
  COURSE_UPDATE_OWN: "course.update_own",
  COURSE_DELETE: "course.delete",
  COURSE_ENROLLMENT: "course.enrollment",
  COURSE_STATISTICS: "course.statistics",
  COURSE_EXPORT: "course.export",
  COURSE_DISCUSSION_READ: "course_discussion.read",
  COURSE_DISCUSSION_MESSAGE_CREATE: "course_discussion.message.create",
  COURSE_DISCUSSION_MESSAGE_REACT: "course_discussion.message.react",
  COURSE_DISCUSSION_MESSAGE_DELETE_OWN: "course_discussion.message.delete_own",
  COURSE_DISCUSSION_MESSAGE_DELETE: "course_discussion.message.delete",
  LEARNING_MODE_USE: "learning_mode.use",
  LEARNING_PROGRESS_UPDATE: "learning_progress.update",
  CERTIFICATE_READ: "certificate.read",
  CERTIFICATE_SHARE: "certificate.share",
  CERTIFICATE_RENDER: "certificate.render",
  FILE_UPLOAD: "file.upload",
  FILE_DELETE: "file.delete",
  RESOURCE_LIBRARY_MANAGE: "resource_library.manage",
  AI_USE: "ai.use",
  AI_THREAD_READ: "ai_thread.read",
  ANNOUNCEMENT_READ: "announcement.read",
  ANNOUNCEMENT_CREATE: "announcement.create",
  ANNOUNCEMENT_DELETE: "announcement.delete",
  NEWS_READ_PUBLIC: "news.read_public",
  NEWS_MANAGE: "news.manage",
  NEWS_MANAGE_OWN: "news.manage_own",
  ARTICLE_READ_PUBLIC: "article.read_public",
  ARTICLE_MANAGE: "article.manage",
  ARTICLE_MANAGE_OWN: "article.manage_own",
  QA_READ_PUBLIC: "qa.read_public",
  QA_MANAGE: "qa.manage",
  QA_MANAGE_OWN: "qa.manage_own",
  REPORT_READ: "report.read",
  STATISTICS_READ_SELF: "statistics.read_self",
  STATISTICS_READ: "statistics.read",
  BILLING_CHECKOUT: "billing.checkout",
  BILLING_MANAGE: "billing.manage",
  INTEGRATION_KEY_MANAGE: "integration_key.manage",
  INTEGRATION_API_USE: "integration_api.use",
  TENANT_MANAGE: "tenant.manage",
  COURSE_AI_GENERATION: "course.ai_generation",
  ACTIVITY_LOG_READ: "activity_log.read"
};
var SYSTEM_ROLE_PERMISSIONS = {
  [SYSTEM_ROLE_SLUGS.GROUP_MANAGER]: [
    PERMISSIONS.PHISHING_REPORT_READ,
    PERMISSIONS.ACCOUNT_READ_SELF,
    PERMISSIONS.ACCOUNT_UPDATE_SELF,
    PERMISSIONS.USER_READ_SELF,
    PERMISSIONS.SETTINGS_READ_SELF,
    PERMISSIONS.SETTINGS_UPDATE_SELF,
    PERMISSIONS.ENV_READ_PUBLIC,
    PERMISSIONS.CATEGORY_READ,
    PERMISSIONS.MANAGED_GROUP_RESULTS_READ,
    PERMISSIONS.DASHBOARD_READ,
    PERMISSIONS.CALENDAR_READ,
    PERMISSIONS.ANNOUNCEMENT_READ,
    PERMISSIONS.NEWS_READ_PUBLIC,
    PERMISSIONS.ARTICLE_READ_PUBLIC,
    PERMISSIONS.QA_READ_PUBLIC
  ],
  [SYSTEM_ROLE_SLUGS.STUDENT]: [
    PERMISSIONS.ACCOUNT_READ_SELF,
    PERMISSIONS.ACCOUNT_UPDATE_SELF,
    PERMISSIONS.USER_READ_SELF,
    PERMISSIONS.SETTINGS_READ_SELF,
    PERMISSIONS.SETTINGS_UPDATE_SELF,
    PERMISSIONS.ENV_READ_PUBLIC,
    PERMISSIONS.CATEGORY_READ,
    PERMISSIONS.COURSE_READ_ASSIGNED,
    PERMISSIONS.COURSE_READ,
    PERMISSIONS.COURSE_DISCUSSION_READ,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_CREATE,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_REACT,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_DELETE_OWN,
    PERMISSIONS.DASHBOARD_READ,
    PERMISSIONS.TODO_TASK_MANAGE_SELF,
    PERMISSIONS.LEARNING_PATH_READ,
    PERMISSIONS.CALENDAR_READ,
    PERMISSIONS.LIVE_TRAINING_READ,
    PERMISSIONS.LIVE_TRAINING_JOIN,
    PERMISSIONS.LEARNING_PROGRESS_UPDATE,
    PERMISSIONS.CERTIFICATE_READ,
    PERMISSIONS.CERTIFICATE_SHARE,
    PERMISSIONS.CERTIFICATE_RENDER,
    PERMISSIONS.FILE_UPLOAD,
    PERMISSIONS.AI_USE,
    PERMISSIONS.ANNOUNCEMENT_READ,
    PERMISSIONS.STATISTICS_READ_SELF,
    PERMISSIONS.BILLING_CHECKOUT,
    PERMISSIONS.NEWS_READ_PUBLIC,
    PERMISSIONS.ARTICLE_READ_PUBLIC,
    PERMISSIONS.QA_READ_PUBLIC
  ],
  [SYSTEM_ROLE_SLUGS.CONTENT_CREATOR]: [
    PERMISSIONS.ACCOUNT_READ_SELF,
    PERMISSIONS.ACCOUNT_UPDATE_SELF,
    PERMISSIONS.USER_READ_SELF,
    PERMISSIONS.SETTINGS_READ_SELF,
    PERMISSIONS.SETTINGS_UPDATE_SELF,
    PERMISSIONS.ENV_READ_PUBLIC,
    PERMISSIONS.CATEGORY_READ,
    PERMISSIONS.GROUP_READ,
    PERMISSIONS.COURSE_READ_ASSIGNED,
    PERMISSIONS.COURSE_READ_MANAGEABLE,
    PERMISSIONS.COURSE_READ,
    PERMISSIONS.COURSE_DISCUSSION_READ,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_CREATE,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_REACT,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_DELETE_OWN,
    PERMISSIONS.LEARNING_PATH_READ,
    PERMISSIONS.LEARNING_PATH_CREATE,
    PERMISSIONS.LEARNING_PATH_UPDATE_OWN,
    PERMISSIONS.LEARNING_PATH_COURSE_UPDATE_OWN,
    PERMISSIONS.CALENDAR_READ,
    PERMISSIONS.LIVE_TRAINING_READ,
    PERMISSIONS.LIVE_TRAINING_JOIN,
    PERMISSIONS.LEARNING_PROGRESS_UPDATE,
    PERMISSIONS.LEARNING_MODE_USE,
    PERMISSIONS.DASHBOARD_READ,
    PERMISSIONS.TODO_TASK_MANAGE_SELF,
    PERMISSIONS.COURSE_CREATE,
    PERMISSIONS.COURSE_UPDATE_OWN,
    PERMISSIONS.COURSE_STATISTICS,
    PERMISSIONS.CERTIFICATE_READ,
    PERMISSIONS.CERTIFICATE_SHARE,
    PERMISSIONS.CERTIFICATE_RENDER,
    PERMISSIONS.FILE_UPLOAD,
    PERMISSIONS.FILE_DELETE,
    PERMISSIONS.AI_USE,
    PERMISSIONS.COURSE_AI_GENERATION,
    PERMISSIONS.ANNOUNCEMENT_READ,
    PERMISSIONS.ANNOUNCEMENT_CREATE,
    PERMISSIONS.NEWS_MANAGE_OWN,
    PERMISSIONS.NEWS_READ_PUBLIC,
    PERMISSIONS.ARTICLE_MANAGE_OWN,
    PERMISSIONS.ARTICLE_READ_PUBLIC,
    PERMISSIONS.QA_MANAGE_OWN,
    PERMISSIONS.QA_READ_PUBLIC,
    PERMISSIONS.REPORT_READ,
    PERMISSIONS.STATISTICS_READ_SELF,
    PERMISSIONS.STATISTICS_READ,
    PERMISSIONS.BILLING_CHECKOUT
  ],
  [SYSTEM_ROLE_SLUGS.TRAINER]: [
    PERMISSIONS.ACCOUNT_READ_SELF,
    PERMISSIONS.ACCOUNT_UPDATE_SELF,
    PERMISSIONS.USER_READ_SELF,
    PERMISSIONS.SETTINGS_READ_SELF,
    PERMISSIONS.SETTINGS_UPDATE_SELF,
    PERMISSIONS.ENV_READ_PUBLIC,
    PERMISSIONS.CATEGORY_READ,
    PERMISSIONS.CALENDAR_READ,
    PERMISSIONS.LIVE_TRAINING_READ,
    PERMISSIONS.LIVE_TRAINING_CREATE,
    PERMISSIONS.LIVE_TRAINING_UPDATE_OWN,
    PERMISSIONS.LIVE_TRAINING_DELETE_OWN,
    PERMISSIONS.LIVE_TRAINING_JOIN,
    PERMISSIONS.LIVE_TRAINING_START,
    PERMISSIONS.LIVE_TRAINING_END,
    PERMISSIONS.LIVE_TRAINING_STATISTICS,
    PERMISSIONS.DASHBOARD_READ,
    PERMISSIONS.TODO_TASK_MANAGE_SELF,
    PERMISSIONS.CERTIFICATE_READ,
    PERMISSIONS.CERTIFICATE_SHARE,
    PERMISSIONS.CERTIFICATE_RENDER,
    PERMISSIONS.FILE_UPLOAD,
    PERMISSIONS.ANNOUNCEMENT_READ
  ],
  [SYSTEM_ROLE_SLUGS.ADMIN]: [
    PERMISSIONS.PHISHING_MANAGE,
    PERMISSIONS.PHISHING_REPORT_READ,
    PERMISSIONS.CONTENT_MARKETPLACE_BROWSE,
    PERMISSIONS.AI_THREAD_READ,
    PERMISSIONS.ACCOUNT_READ_SELF,
    PERMISSIONS.ACCOUNT_UPDATE_SELF,
    PERMISSIONS.USER_READ_SELF,
    PERMISSIONS.SETTINGS_READ_SELF,
    PERMISSIONS.SETTINGS_UPDATE_SELF,
    PERMISSIONS.SETTINGS_MANAGE,
    PERMISSIONS.EMAIL_TEMPLATE_MANAGE,
    PERMISSIONS.AUTOMATION_MANAGE,
    PERMISSIONS.AUTOMATION_LOG_READ,
    PERMISSIONS.ENV_READ_PUBLIC,
    PERMISSIONS.ENV_MANAGE,
    PERMISSIONS.CATEGORY_READ,
    PERMISSIONS.CATEGORY_MANAGE,
    PERMISSIONS.GROUP_READ,
    PERMISSIONS.GROUP_MANAGE,
    PERMISSIONS.LEARNING_PATH_READ,
    PERMISSIONS.LEARNING_PATH_CREATE,
    PERMISSIONS.LEARNING_PATH_UPDATE,
    PERMISSIONS.LEARNING_PATH_DELETE,
    PERMISSIONS.LEARNING_PATH_COURSE_UPDATE,
    PERMISSIONS.LEARNING_PATH_ENROLLMENT,
    PERMISSIONS.LEARNING_PATH_EXPORT,
    PERMISSIONS.CALENDAR_READ,
    PERMISSIONS.LIVE_TRAINING_READ,
    PERMISSIONS.LIVE_TRAINING_CREATE,
    PERMISSIONS.LIVE_TRAINING_UPDATE,
    PERMISSIONS.LIVE_TRAINING_UPDATE_OWN,
    PERMISSIONS.LIVE_TRAINING_DELETE,
    PERMISSIONS.LIVE_TRAINING_DELETE_OWN,
    PERMISSIONS.LIVE_TRAINING_JOIN,
    PERMISSIONS.LIVE_TRAINING_START,
    PERMISSIONS.LIVE_TRAINING_END,
    PERMISSIONS.LIVE_TRAINING_STATISTICS,
    PERMISSIONS.DASHBOARD_READ,
    PERMISSIONS.TODO_TASK_MANAGE_SELF,
    PERMISSIONS.COURSE_READ_ASSIGNED,
    PERMISSIONS.COURSE_READ_MANAGEABLE,
    PERMISSIONS.COURSE_READ,
    PERMISSIONS.COURSE_DISCUSSION_READ,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_CREATE,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_REACT,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_DELETE_OWN,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_DELETE,
    PERMISSIONS.LEARNING_MODE_USE,
    PERMISSIONS.COURSE_CREATE,
    PERMISSIONS.COURSE_UPDATE,
    PERMISSIONS.COURSE_DELETE,
    PERMISSIONS.COURSE_STATISTICS,
    PERMISSIONS.COURSE_ENROLLMENT,
    PERMISSIONS.CERTIFICATE_READ,
    PERMISSIONS.CERTIFICATE_SHARE,
    PERMISSIONS.CERTIFICATE_RENDER,
    PERMISSIONS.FILE_UPLOAD,
    PERMISSIONS.FILE_DELETE,
    PERMISSIONS.RESOURCE_LIBRARY_MANAGE,
    PERMISSIONS.AI_USE,
    PERMISSIONS.COURSE_AI_GENERATION,
    PERMISSIONS.ANNOUNCEMENT_READ,
    PERMISSIONS.ANNOUNCEMENT_CREATE,
    PERMISSIONS.ANNOUNCEMENT_DELETE,
    PERMISSIONS.NEWS_MANAGE,
    PERMISSIONS.NEWS_READ_PUBLIC,
    PERMISSIONS.ARTICLE_MANAGE,
    PERMISSIONS.ARTICLE_READ_PUBLIC,
    PERMISSIONS.QA_MANAGE,
    PERMISSIONS.QA_READ_PUBLIC,
    PERMISSIONS.REPORT_READ,
    PERMISSIONS.STATISTICS_READ_SELF,
    PERMISSIONS.STATISTICS_READ,
    PERMISSIONS.BILLING_CHECKOUT,
    PERMISSIONS.BILLING_MANAGE,
    PERMISSIONS.USER_MANAGE,
    PERMISSIONS.INTEGRATION_KEY_MANAGE,
    PERMISSIONS.INTEGRATION_API_USE,
    PERMISSIONS.TENANT_MANAGE,
    PERMISSIONS.COURSE_EXPORT,
    PERMISSIONS.ACTIVITY_LOG_READ
  ]
};
var SYSTEM_RULE_SET_SLUGS = {
  [SYSTEM_ROLE_SLUGS.STUDENT]: "student-default",
  [SYSTEM_ROLE_SLUGS.CONTENT_CREATOR]: "content_creator-default",
  [SYSTEM_ROLE_SLUGS.TRAINER]: "trainer-default",
  [SYSTEM_ROLE_SLUGS.GROUP_MANAGER]: "group_manager-default",
  [SYSTEM_ROLE_SLUGS.ADMIN]: "admin-default"
};

// src/constants/dashboard.ts
var DASHBOARD_WIDGET_TYPES = {
  AI_MENTOR_PRACTICE: "ai_mentor_practice",
  TODO_LIST: "todo_list",
  EVENT_CALENDAR: "event_calendar",
  DEADLINE_RISKS: "deadline_risks",
  TRAINING_COMPLETION: "training_completion",
  CONTINUE_LEARNING: "continue_learning",
  REQUIRED_COURSES: "required_courses",
  COURSE_COMPLETION: "course_completion",
  CERTIFICATES: "certificates"
};
var DASHBOARD_WIDGET_SIZES = {
  ONE_BY_ONE: "1x1",
  TWO_BY_ONE: "2x1",
  ONE_BY_TWO: "1x2",
  TWO_BY_TWO: "2x2",
  THREE_BY_TWO: "3x2",
  FOUR_BY_ONE: "4x1",
  FOUR_BY_TWO: "4x2",
  FOUR_BY_THREE: "4x3"
};
var DASHBOARD_SCHEMA_VERSION = 2;
var DASHBOARD_WIDGET_CATALOG = {
  [DASHBOARD_WIDGET_TYPES.AI_MENTOR_PRACTICE]: {
    type: DASHBOARD_WIDGET_TYPES.AI_MENTOR_PRACTICE,
    alwaysVisible: false,
    allowedSizes: [DASHBOARD_WIDGET_SIZES.TWO_BY_TWO, DASHBOARD_WIDGET_SIZES.THREE_BY_TWO],
    defaultSize: DASHBOARD_WIDGET_SIZES.THREE_BY_TWO,
    requiredPermissions: [PERMISSIONS.AI_USE],
    requiresAiConfigured: true
  },
  [DASHBOARD_WIDGET_TYPES.TODO_LIST]: {
    type: DASHBOARD_WIDGET_TYPES.TODO_LIST,
    alwaysVisible: false,
    allowedSizes: [
      DASHBOARD_WIDGET_SIZES.TWO_BY_ONE,
      DASHBOARD_WIDGET_SIZES.TWO_BY_TWO,
      DASHBOARD_WIDGET_SIZES.THREE_BY_TWO
    ],
    defaultSize: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO,
    requiredPermissions: [PERMISSIONS.TODO_TASK_MANAGE_SELF]
  },
  [DASHBOARD_WIDGET_TYPES.EVENT_CALENDAR]: {
    type: DASHBOARD_WIDGET_TYPES.EVENT_CALENDAR,
    alwaysVisible: true,
    allowedSizes: [DASHBOARD_WIDGET_SIZES.FOUR_BY_TWO, DASHBOARD_WIDGET_SIZES.FOUR_BY_THREE],
    defaultSize: DASHBOARD_WIDGET_SIZES.FOUR_BY_TWO,
    requiredPermissions: [PERMISSIONS.CALENDAR_READ],
    requiredFeature: FEATURES.CALENDAR
  },
  [DASHBOARD_WIDGET_TYPES.DEADLINE_RISKS]: {
    type: DASHBOARD_WIDGET_TYPES.DEADLINE_RISKS,
    alwaysVisible: false,
    allowedSizes: [
      DASHBOARD_WIDGET_SIZES.TWO_BY_ONE,
      DASHBOARD_WIDGET_SIZES.TWO_BY_TWO,
      DASHBOARD_WIDGET_SIZES.THREE_BY_TWO
    ],
    defaultSize: DASHBOARD_WIDGET_SIZES.TWO_BY_ONE,
    anyPermissions: [PERMISSIONS.STATISTICS_READ, PERMISSIONS.MANAGED_GROUP_RESULTS_READ]
  },
  [DASHBOARD_WIDGET_TYPES.TRAINING_COMPLETION]: {
    type: DASHBOARD_WIDGET_TYPES.TRAINING_COMPLETION,
    alwaysVisible: false,
    allowedSizes: [DASHBOARD_WIDGET_SIZES.ONE_BY_ONE, DASHBOARD_WIDGET_SIZES.TWO_BY_TWO],
    defaultSize: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO,
    anyPermissions: [PERMISSIONS.STATISTICS_READ, PERMISSIONS.MANAGED_GROUP_RESULTS_READ]
  },
  [DASHBOARD_WIDGET_TYPES.CONTINUE_LEARNING]: {
    type: DASHBOARD_WIDGET_TYPES.CONTINUE_LEARNING,
    alwaysVisible: false,
    allowedSizes: [
      DASHBOARD_WIDGET_SIZES.TWO_BY_ONE,
      DASHBOARD_WIDGET_SIZES.TWO_BY_TWO,
      DASHBOARD_WIDGET_SIZES.THREE_BY_TWO
    ],
    defaultSize: DASHBOARD_WIDGET_SIZES.TWO_BY_ONE,
    requiredPermissions: [PERMISSIONS.COURSE_READ_ASSIGNED]
  },
  [DASHBOARD_WIDGET_TYPES.REQUIRED_COURSES]: {
    type: DASHBOARD_WIDGET_TYPES.REQUIRED_COURSES,
    alwaysVisible: false,
    allowedSizes: [
      DASHBOARD_WIDGET_SIZES.TWO_BY_ONE,
      DASHBOARD_WIDGET_SIZES.TWO_BY_TWO,
      DASHBOARD_WIDGET_SIZES.THREE_BY_TWO
    ],
    defaultSize: DASHBOARD_WIDGET_SIZES.TWO_BY_ONE,
    requiredPermissions: [PERMISSIONS.COURSE_READ_ASSIGNED]
  },
  [DASHBOARD_WIDGET_TYPES.COURSE_COMPLETION]: {
    type: DASHBOARD_WIDGET_TYPES.COURSE_COMPLETION,
    alwaysVisible: false,
    allowedSizes: [DASHBOARD_WIDGET_SIZES.ONE_BY_ONE, DASHBOARD_WIDGET_SIZES.TWO_BY_TWO],
    defaultSize: DASHBOARD_WIDGET_SIZES.ONE_BY_ONE,
    requiredPermissions: [PERMISSIONS.COURSE_READ_ASSIGNED]
  },
  [DASHBOARD_WIDGET_TYPES.CERTIFICATES]: {
    type: DASHBOARD_WIDGET_TYPES.CERTIFICATES,
    alwaysVisible: false,
    allowedSizes: [DASHBOARD_WIDGET_SIZES.TWO_BY_ONE, DASHBOARD_WIDGET_SIZES.TWO_BY_TWO],
    defaultSize: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO,
    requiredPermissions: [PERMISSIONS.CERTIFICATE_READ]
  }
};
var DASHBOARD_DEFAULT_LAYOUTS = {
  [SYSTEM_ROLE_SLUGS.GROUP_MANAGER]: [
    { type: DASHBOARD_WIDGET_TYPES.EVENT_CALENDAR, size: DASHBOARD_WIDGET_SIZES.FOUR_BY_TWO },
    { type: DASHBOARD_WIDGET_TYPES.DEADLINE_RISKS, size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO },
    {
      type: DASHBOARD_WIDGET_TYPES.TRAINING_COMPLETION,
      size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO
    }
  ],
  [SYSTEM_ROLE_SLUGS.ADMIN]: [
    { type: DASHBOARD_WIDGET_TYPES.DEADLINE_RISKS, size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO },
    { type: DASHBOARD_WIDGET_TYPES.EVENT_CALENDAR, size: DASHBOARD_WIDGET_SIZES.FOUR_BY_TWO },
    {
      type: DASHBOARD_WIDGET_TYPES.TRAINING_COMPLETION,
      size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO
    },
    {
      type: DASHBOARD_WIDGET_TYPES.AI_MENTOR_PRACTICE,
      size: DASHBOARD_WIDGET_SIZES.THREE_BY_TWO
    },
    { type: DASHBOARD_WIDGET_TYPES.TODO_LIST, size: DASHBOARD_WIDGET_SIZES.THREE_BY_TWO }
  ],
  [SYSTEM_ROLE_SLUGS.CONTENT_CREATOR]: [
    { type: DASHBOARD_WIDGET_TYPES.DEADLINE_RISKS, size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO },
    { type: DASHBOARD_WIDGET_TYPES.EVENT_CALENDAR, size: DASHBOARD_WIDGET_SIZES.FOUR_BY_TWO },
    {
      type: DASHBOARD_WIDGET_TYPES.TRAINING_COMPLETION,
      size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO
    },
    {
      type: DASHBOARD_WIDGET_TYPES.AI_MENTOR_PRACTICE,
      size: DASHBOARD_WIDGET_SIZES.THREE_BY_TWO
    },
    { type: DASHBOARD_WIDGET_TYPES.TODO_LIST, size: DASHBOARD_WIDGET_SIZES.THREE_BY_TWO }
  ],
  [SYSTEM_ROLE_SLUGS.TRAINER]: [
    {
      type: DASHBOARD_WIDGET_TYPES.AI_MENTOR_PRACTICE,
      size: DASHBOARD_WIDGET_SIZES.THREE_BY_TWO
    },
    { type: DASHBOARD_WIDGET_TYPES.EVENT_CALENDAR, size: DASHBOARD_WIDGET_SIZES.FOUR_BY_TWO },
    { type: DASHBOARD_WIDGET_TYPES.TODO_LIST, size: DASHBOARD_WIDGET_SIZES.THREE_BY_TWO }
  ],
  [SYSTEM_ROLE_SLUGS.STUDENT]: [
    {
      type: DASHBOARD_WIDGET_TYPES.CONTINUE_LEARNING,
      size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO
    },
    {
      type: DASHBOARD_WIDGET_TYPES.AI_MENTOR_PRACTICE,
      size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO
    },
    { type: DASHBOARD_WIDGET_TYPES.EVENT_CALENDAR, size: DASHBOARD_WIDGET_SIZES.FOUR_BY_TWO },
    { type: DASHBOARD_WIDGET_TYPES.TODO_LIST, size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO },
    {
      type: DASHBOARD_WIDGET_TYPES.REQUIRED_COURSES,
      size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO
    },
    {
      type: DASHBOARD_WIDGET_TYPES.COURSE_COMPLETION,
      size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO
    },
    { type: DASHBOARD_WIDGET_TYPES.CERTIFICATES, size: DASHBOARD_WIDGET_SIZES.TWO_BY_TWO }
  ]
};
var STUDENT_DASHBOARD_LIMITS = {
  CONTINUE_COURSES: 5,
  REQUIRED_COURSES: 5
};
var DASHBOARD_CALENDAR_VIEWS = {
  ALL: "all",
  UPCOMING: "upcoming"
};
var STUDENT_COURSE_URGENCY = {
  OVERDUE: "overdue",
  DUE_SOON: "dueSoon",
  SCHEDULED: "scheduled",
  NO_DEADLINE: "noDeadline"
};
var DASHBOARD_DEADLINE_RISK_TYPES = {
  OVERDUE: "overdue",
  DUE_SOON: "dueSoon"
};
var DASHBOARD_DEADLINE_RISK_URGENCY_ORDERS = {
  MOST_URGENT: "mostUrgent",
  LEAST_URGENT: "leastUrgent"
};
var DASHBOARD_DEADLINE_RISK_GROUP_SORT_FIELDS = {
  NAME: "name",
  DUE_DATE: "dueDate",
  URGENCY: "urgency",
  STUDENT_COUNT: "studentCount"
};
var DASHBOARD_DEADLINE_RISK_SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc"
};

// src/constants/emailBranding.ts
var DEFAULT_EMAIL_PRIMARY_COLOR = "#4796FD";

// src/constants/entityTypes.ts
var ENTITY_TYPES = {
  COURSE: "course",
  CHAPTER: "chapter",
  LESSON: "lesson",
  QUESTION: "question",
  ASSESSMENT_QUESTION: "assessment_question",
  NEWS: "news",
  ARTICLES: "articles",
  LEARNING_PATH: "learning_path",
  QA: "qa",
  USER: "user",
  CATEGORY: "category",
  ANNOUNCEMENT: "announcement",
  GLOBAL_SETTINGS: "global_settings",
  LIVE_TRAINING: "live_training"
};

// src/constants/fileTypes.ts
var ALLOWED_LESSON_IMAGE_FILE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/bmp",
  "image/tiff"
];
var SUPPORTED_IMAGE_VARIANT_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp"
];
var ALLOWED_VIDEO_FILE_TYPES = [
  "video/mp4",
  "video/quicktime",
  "video/webm",
  "video/ogg",
  "video/avi",
  "video/mov",
  "video/wmv"
];
var ALLOWED_PRESENTATION_FILE_TYPES = [
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.oasis.opendocument.presentation"
];
var ALLOWED_EXCEL_FILE_TYPES = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv"
];
var ALLOWED_WORD_FILE_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];
var ALLOWED_PDF_FILE_TYPES = ["application/pdf"];
var ALLOWED_CERTIFICATE_SIGNATURE_FILE_TYPES = [
  "image/png",
  "image/svg+xml",
  "application/xml"
];
var COURSE_AUTHORING_SOURCE_FILE_TYPES = [
  ...ALLOWED_PDF_FILE_TYPES,
  ...ALLOWED_WORD_FILE_TYPES.filter((type) => type !== "application/msword"),
  "text/plain",
  "text/markdown",
  "text/x-markdown"
];
var MAX_COURSE_AUTHORING_SOURCE_SIZE = 25 * 1024 * 1024;

// src/constants/globalSearch.ts
var GLOBAL_SEARCH_MODES = {
  KEYWORD: "keyword",
  HYBRID: "hybrid"
};
var GLOBAL_SEARCH_SEMANTIC_STATUSES = {
  READY: "ready",
  UNAVAILABLE: "unavailable",
  PENDING: "pending"
};
var GLOBAL_SEARCH_RESULT_TYPES = {
  COURSE: "course",
  LESSON: "lesson",
  LEARNING_PATH: "learningPath",
  NEWS: "news",
  ARTICLE: "article",
  QA: "qa"
};

// src/constants/languages.ts
var SUPPORTED_LANGUAGES = {
  EN: "en",
  PL: "pl",
  DE: "de",
  LT: "lt",
  CS: "cs",
  ES: "es",
  FR: "fr"
};
var SUPPORTED_LANGUAGE_VALUES = new Set(Object.values(SUPPORTED_LANGUAGES));
var isSupportedLanguage = (language) => SUPPORTED_LANGUAGE_VALUES.has(language);

// src/constants/learningPath.ts
var LEARNING_PATH_STATUSES = {
  DRAFT: "draft",
  PUBLISHED: "published",
  PRIVATE: "private"
};
var LEARNING_PATH_ENROLLMENT_TYPES = {
  DIRECT: "direct",
  GROUP: "group"
};
var LEARNING_PATH_PROGRESS_STATUSES = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed"
};
var LEARNING_PATH_ENTITY_TYPES = {
  LEARNING_PATH: "learning_path",
  COURSE: "course"
};
var LEARNING_PATH_CERTIFICATE_STATUSES = {
  ACTIVE: "active",
  EXPIRED: "expired"
};

// src/constants/lessonTypes.ts
var LESSON_TYPES = {
  CONTENT: "content",
  QUIZ: "quiz",
  AI_MENTOR: "ai_mentor",
  EMBED: "embed",
  SCORM: "scorm",
  LIVE_TRAINING: "live_training"
};

// src/constants/liveTraining.ts
var CALENDAR_EVENT_STATUSES = {
  SCHEDULED: "scheduled",
  CANCELLED: "cancelled",
  ENDED: "ended",
  EXPIRED: "expired"
};
var LIVE_TRAINING_DELIVERY_TYPES = {
  ONLINE: "online",
  OFFLINE: "offline"
};
var LIVE_TRAINING_VISIBILITY_SCOPES = {
  ALL: "all",
  LINKED_COURSES: "linked_courses"
};
var LIVE_TRAINING_STATUSES = {
  SCHEDULED: "scheduled",
  ACTIVE: "active",
  ENDED: "ended",
  CANCELLED: "cancelled",
  EXPIRED: "expired"
};
var LIVE_TRAINING_SESSION_STATUSES = {
  WAITING: "waiting",
  ACTIVE: "active",
  ENDED: "ended",
  FAILED: "failed"
};
var LIVE_TRAINING_MEMBER_ROLES = {
  HOST: "host",
  CO_TRAINER: "co_trainer",
  MODERATOR: "moderator",
  OBSERVER: "observer"
};
var LIVE_TRAINING_PARTICIPANT_ROLES = {
  ...LIVE_TRAINING_MEMBER_ROLES,
  ADMIN: "admin"
};
var LIVE_TRAINING_LINK_ENTITY_TYPES = {
  COURSE: "course"
};
var LIVE_TRAINING_RESOURCE_RELATIONSHIP_TYPES = {
  BEFORE: "live_training_before",
  AFTER: "live_training_after"
};
var DEFAULT_LIVE_TRAINING_SETTINGS = {
  viewerPermissions: {
    microphoneEnabled: false,
    cameraEnabled: false
  }
};
var LIVE_TRAINING_MAX_PARTICIPANTS_LIMIT = 100;
var LIVE_TRAINING_TITLE_MAX_LENGTH = 120;
var LIVE_TRAINING_DESCRIPTION_MAX_LENGTH = 500;
var LIVE_TRAINING_SOCKET_ROOMS = {
  LIVE_TRAINING: "live-training",
  LIVE_TRAINING_SESSION: "live-training-session",
  LIVE_TRAINING_USER: "live-training-user"
};
var LIVE_TRAINING_SOCKET_CLIENT_EVENTS = {
  SUBSCRIBE: "liveTraining:subscribe",
  UNSUBSCRIBE: "liveTraining:unsubscribe",
  SESSION_START: "liveTraining:session:start",
  SESSION_END: "liveTraining:session:end",
  PARTICIPANT_HEARTBEAT: "liveTraining:participant:heartbeat",
  PARTICIPANT_LEAVE: "liveTraining:participant:leave"
};
var LIVE_TRAINING_SOCKET_SERVER_EVENTS = {
  SESSION_STARTED: "liveTraining:session:started",
  SESSION_ENDED: "liveTraining:session:ended",
  SESSION_STATUS_CHANGED: "liveTraining:session:statusChanged",
  PARTICIPANT_JOINED: "liveTraining:participant:joined",
  PARTICIPANT_LEFT: "liveTraining:participant:left",
  PARTICIPANT_UPDATED: "liveTraining:participant:updated",
  ATTENDANCE_UPDATED: "liveTraining:attendance:updated",
  POPUP_AVAILABLE: "liveTraining:popup:available",
  ERROR: "liveTraining:error"
};
var LIVE_TRAINING_SOCKET_ROOM_BUILDERS = {
  liveTraining: (liveTrainingId) => `${LIVE_TRAINING_SOCKET_ROOMS.LIVE_TRAINING}:${liveTrainingId}`,
  liveTrainingSession: (sessionId) => `${LIVE_TRAINING_SOCKET_ROOMS.LIVE_TRAINING_SESSION}:${sessionId}`,
  liveTrainingUser: (userId) => `${LIVE_TRAINING_SOCKET_ROOMS.LIVE_TRAINING_USER}:${userId}`
};

// src/constants/loginMethods.ts
var OAUTH_LOGIN_METHODS = {
  GOOGLE: "google",
  MICROSOFT: "microsoft",
  SLACK: "slack"
};
var EMAIL_LOGIN_METHODS = {
  MAGIC_LINK: "magicLink",
  PASSWORD: "password"
};
var LOGIN_METHODS = {
  ...OAUTH_LOGIN_METHODS,
  ...EMAIL_LOGIN_METHODS
};
var LOGIN_METHOD_ERROR_KEYS = {
  DISABLED: "loginMethods.errors.disabled",
  MISSING_CONFIGURATION: "loginMethods.errors.missingConfiguration",
  LAST_METHOD: "loginMethods.errors.lastMethod"
};

// src/constants/loginPageDocuments.ts
var MAX_LOGIN_PAGE_DOCUMENTS = 3;
var LOGIN_PAGE_DOCUMENTS_FILE_TYPES = ["application/pdf"];

// src/constants/lumaCourseGeneration.ts
var COURSE_GENERATION_SYNC_STATUS = {
  NOT_STARTED: "not_started",
  PROCESSING: "processing",
  FAILED: "failed",
  PROCESSED: "processed",
  DISMISSED: "dismissed"
};

// src/constants/lumaFileIngestion.ts
var LUMA_FILE_INGESTION_MAX_SIZE_MB = 10;
var LUMA_FILE_INGESTION_MAX_SIZE_BYTES = LUMA_FILE_INGESTION_MAX_SIZE_MB * 1024 * 1024;
var LUMA_FILE_INGESTION_ALLOWED_MIME_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "text/markdown",
  "text/x-markdown",
  "application/x-markdown"
];
var LUMA_FILE_INGESTION_ALLOWED_EXTENSIONS = [
  ".pdf",
  ".docx",
  ".txt",
  ".md",
  ".xmd"
];

// src/constants/masterCourse.ts
var COURSE_ORIGIN_TYPES = {
  REGULAR: "regular",
  MASTER: "master",
  EXPORTED: "exported"
};
var MASTER_COURSE_EXPORT_SYNC_STATUSES = {
  PENDING: "pending",
  PROCESSING: "processing",
  ACTIVE: "active",
  FAILED: "failed",
  PAUSED: "paused"
};
var MASTER_COURSE_ENTITY_TYPES = {
  COURSE: "course",
  CHAPTER: "chapter",
  LESSON: "lesson",
  QUESTION: "question",
  OPTION: "option",
  RESOURCE: "resource",
  RESOURCE_ENTITY: "resource_entity",
  AI_MENTOR_LESSON: "ai_mentor_lesson"
};

// src/constants/mcpScopes.ts
var MCP_SCOPES = {
  ACCOUNT_ACCESS: "account:access",
  AUTHORING: "authoring",
  SEARCH: "search",
  STUDENT_READ: "student:read",
  SEARCH_READ: "search:read",
  COURSES_READ: "courses:read",
  COURSES_WRITE: "courses:write",
  CATEGORIES_READ: "categories:read",
  CATEGORIES_WRITE: "categories:write",
  ARTICLES_READ: "articles:read",
  ARTICLES_WRITE: "articles:write",
  NEWS_READ: "news:read",
  NEWS_WRITE: "news:write",
  QA_READ: "qa:read",
  QA_WRITE: "qa:write",
  LEARNING_PATHS_READ: "learning_paths:read",
  LEARNING_PATHS_WRITE: "learning_paths:write",
  USERS_READ: "users:read",
  USERS_WRITE: "users:write",
  GROUPS_READ: "groups:read",
  GROUPS_WRITE: "groups:write",
  PLATFORM_READ: "platform:read",
  PLATFORM_WRITE: "platform:write",
  FILES_WRITE: "files:write"
};
var MCP_REQUESTABLE_SCOPES = Object.values(MCP_SCOPES).filter(
  (scope) => scope !== MCP_SCOPES.AUTHORING && scope !== MCP_SCOPES.SEARCH
);

// src/constants/messageRole.ts
var MESSAGE_ROLE = {
  SYSTEM: "system",
  USER: "user",
  MENTOR: "assistant",
  TOOL: "tool",
  SUMMARY: "summary"
};

// src/constants/newsSettings.ts
var ALLOWED_NEWS_SETTINGS = {
  NEWS_ENABLED: "newsEnabled",
  UNREGISTERED_USER_NEWS_ACCESSIBILITY: "unregisteredUserNewsAccessibility"
};
var NEWS_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published"
};

// src/constants/qaSettings.ts
var ALLOWED_QA_SETTINGS = {
  QA_ENABLED: "QAEnabled",
  UNREGISTERED_USER_QA_ACCESSIBILITY: "unregisteredUserQAAccessibility"
};

// src/constants/registrationForm.ts
var FORM_TYPES = {
  REGISTRATION: "registration"
};
var FORM_FIELD_TYPES = /* @__PURE__ */ ((FORM_FIELD_TYPES2) => {
  FORM_FIELD_TYPES2["CHECKBOX"] = "checkbox";
  return FORM_FIELD_TYPES2;
})(FORM_FIELD_TYPES || {});

// src/constants/resourceLibrary.ts
var RESOURCE_LIBRARY_ASSET_TYPE = {
  IMAGE: "image",
  VIDEO: "video",
  PDF: "pdf",
  PRESENTATION: "presentation",
  DOCUMENT: "document",
  OTHER: "other"
};
var RESOURCE_VISIBILITY = {
  PUBLIC: "public",
  PRIVATE: "private",
  HIDDEN: "hidden"
};

// src/constants/richTextResource.ts
var RICH_TEXT_RESOURCE_TYPE = {
  IMAGE: "image",
  VIDEO: "video",
  PRESENTATION: "presentation",
  PDF: "pdf",
  DOCUMENT: "document",
  OTHER: "other"
};
var RICH_TEXT_RESOURCE_DISPLAY_MODE = {
  PREVIEW: "preview",
  DOWNLOAD: "download"
};
function classifyRichTextResourceType(mimeType) {
  if (ALLOWED_LESSON_IMAGE_FILE_TYPES.includes(mimeType)) return RICH_TEXT_RESOURCE_TYPE.IMAGE;
  if (ALLOWED_VIDEO_FILE_TYPES.includes(mimeType)) return RICH_TEXT_RESOURCE_TYPE.VIDEO;
  if (ALLOWED_PRESENTATION_FILE_TYPES.includes(mimeType))
    return RICH_TEXT_RESOURCE_TYPE.PRESENTATION;
  if (ALLOWED_PDF_FILE_TYPES.includes(mimeType)) return RICH_TEXT_RESOURCE_TYPE.PDF;
  if (ALLOWED_WORD_FILE_TYPES.includes(mimeType) || ALLOWED_EXCEL_FILE_TYPES.includes(mimeType))
    return RICH_TEXT_RESOURCE_TYPE.DOCUMENT;
  return RICH_TEXT_RESOURCE_TYPE.OTHER;
}

// src/constants/scorm.ts
var SCORM_STANDARD = {
  SCORM_1_2: "scorm_1_2",
  SCORM_2004: "scorm_2004"
};
var SCORM_PACKAGE_ENTITY_TYPE = {
  COURSE: "course",
  LESSON: "lesson"
};
var SCORM_PACKAGE_STATUS = {
  PROCESSING: "processing",
  READY: "ready",
  FAILED: "failed"
};
var SCORM_IMPORT_ACTION = {
  CREATE_COURSE: "create-course",
  CREATE_LESSON: "create-lesson",
  ATTACH_LESSON_PACKAGE: "attach-lesson-package"
};
var SCORM_IMPORT_SOCKET = {
  EVENTS: {
    STATUS_CHANGED: "scorm-import-status-change"
  },
  MESSAGE_KEYS: {
    PROCESSING: "adminScorm.importProcessing.description",
    READY: "adminScorm.importSuccess.description",
    FAILED_COURSE: "adminScorm.importFailure.courseDescription",
    FAILED_LESSON: "adminScorm.importFailure.lessonDescription"
  }
};
var SCORM_COMPLETION_STATUS = {
  COMPLETED: "completed",
  INCOMPLETE: "incomplete",
  NOT_ATTEMPTED: "not_attempted",
  UNKNOWN: "unknown"
};
var SCORM_SUCCESS_STATUS = {
  PASSED: "passed",
  FAILED: "failed",
  UNKNOWN: "unknown"
};

// src/constants/sessionRevocation.ts
var SESSION_REVOCATION_SOCKET = {
  EVENTS: {
    PERMISSIONS_UPDATED: "permissions-updated"
  },
  REASONS: {
    ROLES_CHANGED: "roles_changed"
  },
  MESSAGE_KEYS: {
    PERMISSIONS_UPDATED: "sessionRevocation.permissionsUpdated"
  }
};

// src/constants/socket.ts
var USER_SOCKET_EVENTS = {
  JOIN: "join:user",
  LEAVE: "leave:user"
};

// src/constants/supportMode.ts
var SUPPORT_SESSION_STATUSES = {
  PENDING: "pending",
  ACTIVE: "active",
  REVOKED: "revoked"
};
var SUPPORT_USER_SCOPES = {
  ADMINS: "admins",
  ALL: "all"
};

// src/constants/tenant.ts
var TENANT_STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive"
};

// src/constants/theme.ts
var HEX_COLOR_REGEX = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

// src/constants/tus.ts
var DEFAULT_TUS_CHUNK_SIZE = 50 * 1024 * 1024;
var DEFAULT_TUS_TTL_MS = 4 * 60 * 60 * 1e3;

// src/constants/videoAutoplayActions.ts
var VIDEO_AUTOPLAY = {
  AUTOPLAY: "autoplay",
  AUTOPLAY_WITH_PLAY_NEXT: "autoplay_with_play_next",
  PLAY_NEXT: "play_next",
  NO_AUTOPLAY: "no_autoplay"
};

// src/constants/videoProviders.ts
var VIDEO_EMBED_PROVIDERS = {
  SELF: "self",
  YOUTUBE: "youtube",
  VIMEO: "vimeo",
  BUNNY: "bunny",
  UNKNOWN: "unknown"
};

// src/constants/voiceAction.ts
var VOICE_ACTION = {
  TRANSCRIPT: "transcript",
  VOICE_MENTOR: "voiceMentor"
};
var VOICE_CAPTURE_PROFILE = {
  CONTINUOUS_PCM: "continuous_pcm",
  VAD_SEGMENTED: "vad_segmented"
};
var VOICE_ENDPOINTING_MODE = {
  CLIENT_VAD: "client",
  PROVIDER: "provider"
};
var VOICE_SOCKET_EVENT = {
  START_AUDIO: "startAudio",
  AUDIO_STARTED: "audioStarted",
  AUDIO_CHUNK: "audioChunk",
  AUDIO_CHUNK_ACCEPTED: "audio:chunked",
  AUDIO_CHUNK_ERROR: "audio:chunk_error",
  AUDIO_SPEECH: "audioSpeech",
  AUDIO_OUTPUT_ALIGNMENT: "audioOutputAlignment",
  AUDIO_INTERRUPTED: "audioInterrupted",
  AUDIO_OUTPUT_COMPLETED: "audioOutputCompleted",
  AUDIO_RECONNECT: "audio_reconnect",
  AUDIO_RECOVERY_STARTED: "audio:recovery_started",
  AUDIO_RECOVERED: "audio:recovered",
  AUDIO_RECONNECT_ERROR: "audio:reconnect_error",
  SESSION_METADATA_CLEARED: "voice:sessionMetadataCleared",
  LEARNER_TRANSCRIPTION: "learnerTranscription",
  MENTOR_RESPONSE_DELTA: "mentorResponseDelta",
  MENTOR_RESPONSE_COMPLETED: "mentorResponseCompleted",
  STOP_AUDIO: "stopAudio",
  CANCEL_AUDIO: "cancelAudio",
  CLIENT_SPEECH_START: "clientSpeechStart",
  CLIENT_SPEECH_END: "clientSpeechEnd",
  TRIGGER_TTS: "triggerTTS"
};

// src/constants/voiceModeState.ts
var VOICE_MODE_STATE = {
  IDLE: "idle",
  LISTENING: "listening",
  THINKING: "thinking",
  SPEAKING: "speaking"
};

// src/types/onboarding.ts
var OnboardingPages = /* @__PURE__ */ ((OnboardingPages2) => {
  OnboardingPages2["DASHBOARD"] = "dashboard";
  OnboardingPages2["COURSES"] = "courses";
  OnboardingPages2["ANNOUNCEMENTS"] = "announcements";
  OnboardingPages2["PROFILE"] = "profile";
  OnboardingPages2["SETTINGS"] = "settings";
  OnboardingPages2["PROVIDER_INFORMATION"] = "providerInformation";
  return OnboardingPages2;
})(OnboardingPages || {});

// src/types/videoUploadTypes.ts
var VIDEO_UPLOAD_STATUS = {
  QUEUED: "queued",
  UPLOADED: "uploaded",
  PROCESSED: "processed",
  FAILED: "failed"
};
var VIDEO_PROVIDERS = {
  BUNNY: "bunny",
  S3: "s3"
};
var VIDEO_PROCESSING_STATUSES = {
  PROCESSING: "processing",
  FAILED: "failed"
};

// src/types/voiceSocketEvents.ts
import { LEARNER_TRANSCRIPT_STATUSES } from "@mentingo/luma-sdk/contracts";

// src/utils/automationBranchAvailability.ts
function getAncestorConditionOutcomes(workflow, stepId, event) {
  const facts = {};
  const visited = /* @__PURE__ */ new Set();
  let step = workflow.steps.find((step2) => step2.id === stepId);
  while (step?.parentId && !visited.has(step.id)) {
    visited.add(step.id);
    const parent = workflow.steps.find((candidate) => candidate.id === step.parentId);
    if (parent?.type === "condition" && parent.config.field) {
      const key = getCanonicalAutomationField(event, parent.config.field);
      if (!(key in facts)) facts[key] = step.position === 0;
    }
    step = parent;
  }
  return facts;
}
function isAutomationFieldAvailable(event, field, facts) {
  const definition = event.fields.find(
    (item) => item.key === getCanonicalAutomationField(event, field)
  );
  const rule = definition?.availableWhen;
  return !rule || facts[rule.field] === rule.equals;
}

// src/utils/automationWorkflow.ts
var getAutomationWorkflowIssues = (workflow, options = {}) => {
  const issues = [];
  const addValidationIssue = (code, message, stepId) => {
    issues.push({ code, message, ...stepId ? { stepId } : {} });
  };
  if (workflow.steps.length === 0) {
    if (workflow.rootStepId !== null)
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_ROOT,
        "An empty workflow cannot reference a root."
      );
    if (options.requireComplete)
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.MISSING_TRIGGER,
        "Select a starting event."
      );
    return issues;
  }
  const byId = /* @__PURE__ */ new Map();
  const children = /* @__PURE__ */ new Map();
  for (const step of workflow.steps) {
    if (!step.id || byId.has(step.id))
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.DUPLICATE_STEP_ID,
        "Step identities must be unique and nonempty.",
        step.id
      );
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(step.id))
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_STEP_ID,
        "Step identities must be UUIDs.",
        step.id
      );
    byId.set(step.id, step);
    if (options.automationId && step.automationId && step.automationId !== options.automationId) {
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.CROSS_AUTOMATION_REFERENCE,
        "The step belongs to another automation.",
        step.id
      );
    }
    if (!Number.isSafeInteger(step.position) || step.position < 0) {
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_POSITION,
        "Sibling positions must be nonnegative integers.",
        step.id
      );
    }
    if (step.parentId !== null) {
      const siblings = children.get(step.parentId) ?? [];
      siblings.push(step);
      children.set(step.parentId, siblings);
    }
    const stepType = step.type;
    if (stepType !== "trigger" && stepType !== "send_email" && stepType !== "condition") {
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.UNSUPPORTED_STEP_TYPE,
        "This step type is not supported.",
        step.id
      );
    }
  }
  const roots = workflow.steps.filter((step) => step.parentId === null);
  if (roots.length !== 1 || roots[0]?.id !== workflow.rootStepId) {
    addValidationIssue(
      AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_ROOT,
      "The workflow must have exactly one root matching rootStepId."
    );
  }
  const root = workflow.rootStepId === null ? void 0 : byId.get(workflow.rootStepId);
  if (!root || root.type !== "trigger")
    addValidationIssue(
      AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_TRIGGER_ROOT,
      "The root must be a trigger."
    );
  if (root && root.position !== 0)
    addValidationIssue(
      AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_POSITION,
      "The root position must be zero.",
      root.id
    );
  for (const step of workflow.steps) {
    if (step.type === "trigger" && step.id !== workflow.rootStepId) {
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.NON_ROOT_TRIGGER,
        "Only the root can be a trigger.",
        step.id
      );
    }
    if (step.parentId === step.id)
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.SELF_PARENT,
        "A step cannot be its own parent.",
        step.id
      );
    if (step.parentId !== null && !byId.has(step.parentId)) {
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.MISSING_PARENT,
        "The parent must exist in this workflow.",
        step.id
      );
    }
    const ancestors = /* @__PURE__ */ new Set();
    let current = step;
    while (current) {
      if (ancestors.has(current.id)) {
        addValidationIssue(
          AUTOMATION_VALIDATION_ISSUE_CODES.CYCLE,
          "The workflow cannot contain cycles.",
          step.id
        );
        break;
      }
      ancestors.add(current.id);
      if (current.parentId === null) break;
      current = byId.get(current.parentId);
    }
    if (options.requireComplete && step.type === "trigger") {
      if (!step.config.eventKind || !Object.values(AUTOMATION_EVENT_KINDS).includes(step.config.eventKind)) {
        addValidationIssue(
          AUTOMATION_VALIDATION_ISSUE_CODES.MISSING_EVENT,
          "Select a supported starting event.",
          step.id
        );
      }
    }
    if (options.requireComplete && step.type === "condition" && !step.config.field) {
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.MISSING_CONDITION_FIELD,
        "Choose a Yes/No field for this condition.",
        step.id
      );
    }
    if (options.requireComplete && step.type === "send_email") {
      const reference = step.config.template;
      if (!reference) {
        addValidationIssue(
          AUTOMATION_VALIDATION_ISSUE_CODES.MISSING_TEMPLATE,
          "Select an email template.",
          step.id
        );
      } else if (reference.type === "builtin") {
        if (!Object.values(BUILT_IN_EMAIL_TEMPLATE_KEYS).includes(reference.key)) {
          addValidationIssue(
            AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_TEMPLATE,
            "Select a supported built-in template.",
            step.id
          );
        }
      } else if (reference.type === "custom") {
        if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
          reference.id
        )) {
          addValidationIssue(
            AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_TEMPLATE,
            "Custom templates require a UUID.",
            step.id
          );
        }
      } else {
        addValidationIssue(
          AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_TEMPLATE,
          "Unsupported template reference.",
          step.id
        );
      }
    }
  }
  for (const [parentId, siblings] of children) {
    const parent = byId.get(parentId);
    const positions = siblings.map((step) => step.position);
    if (parent?.type === "condition") {
      if (new Set(positions).size !== positions.length || positions.some((position) => position !== 0 && position !== 1)) {
        addValidationIssue(
          AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_CONDITION_BRANCHES,
          "A condition can have one Yes branch and one No branch.",
          parentId
        );
      }
    } else if (siblings.length > 1 || positions[0] !== 0) {
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_SUCCESSOR,
        "This step can have only one successor at position zero.",
        parentId
      );
    }
  }
  const reachable = /* @__PURE__ */ new Set();
  const markReachableSteps = (id) => {
    if (reachable.has(id)) return;
    reachable.add(id);
    for (const child of children.get(id) ?? []) markReachableSteps(child.id);
  };
  if (root) markReachableSteps(root.id);
  for (const step of workflow.steps) {
    if (!reachable.has(step.id))
      addValidationIssue(
        AUTOMATION_VALIDATION_ISSUE_CODES.DISCONNECTED_STEP,
        "Every step must be reachable from the root.",
        step.id
      );
  }
  if (options.requireComplete && !workflow.steps.some((step) => step.type === "send_email")) {
    addValidationIssue(
      AUTOMATION_VALIDATION_ISSUE_CODES.MISSING_ACTION,
      "Add at least one email action."
    );
  }
  return issues;
};
var flattenAutomationWorkflow = (workflow) => {
  const issues = getAutomationWorkflowIssues(workflow);
  if (issues.length) throw new Error(issues[0].message);
  const path = [];
  const appendStepAndDescendants = (id) => {
    const step = workflow.steps.find((item) => item.id === id);
    path.push(step);
    for (const child of getChildrenInExecutionOrder(workflow, id))
      appendStepAndDescendants(child.id);
  };
  if (workflow.rootStepId) appendStepAndDescendants(workflow.rootStepId);
  return path;
};
var evaluateAutomationWorkflow = (workflow, fields) => {
  const ordered = flattenAutomationWorkflow(workflow);
  const root = ordered[0];
  if (root?.type === "trigger" && root.config.eventKind)
    fields = { ...deriveAutomationBranchFieldValues(root.config.eventKind, fields), ...fields };
  const path = [];
  const traces = new Map(
    ordered.map((step) => [
      step.id,
      {
        stepId: step.id,
        type: step.type,
        ...step.type === "condition" ? { field: step.config.field } : {},
        matchedCount: 0,
        skippedCount: 1,
        failedCount: 0,
        trueCount: 0,
        falseCount: 0
      }
    ])
  );
  let current = ordered[0];
  let issue;
  while (current) {
    const trace = traces.get(current.id);
    trace.skippedCount = 0;
    path.push(current);
    let position = 0;
    if (current.type === "condition") {
      const field = current.config.field;
      const trigger = ordered[0];
      const sourceKey = field && trigger?.type === "trigger" && trigger.config.eventKind ? resolveAutomationEventFieldSourceKey(trigger.config.eventKind, field) : void 0;
      const value = field ? fields[field] ?? (sourceKey ? fields[sourceKey] : void 0) : void 0;
      if (typeof value !== "boolean") {
        trace.failedCount = 1;
        issue = {
          code: AUTOMATION_VALIDATION_ISSUE_CODES.INVALID_CONDITION_VALUE,
          message: "The condition needs a Yes/No value from the event.",
          stepId: current.id
        };
        break;
      }
      trace.trueCount = Number(value);
      trace.falseCount = Number(!value);
      position = value ? 0 : 1;
    }
    trace.matchedCount = 1;
    current = ordered.find((step) => step.parentId === current.id && step.position === position);
  }
  return { path, steps: [...traces.values()], ...issue ? { issue } : {} };
};
var cloneAutomationWorkflow = (workflow) => JSON.parse(JSON.stringify(workflow));
var assertValidWorkflowStructure = (workflow) => {
  const issues = getAutomationWorkflowIssues(workflow, { allowBranches: true });
  if (issues.length) throw new Error(issues[0].message);
};
var getChildrenInExecutionOrder = (workflow, parentId) => workflow.steps.filter((step) => step.parentId === parentId).sort((a, b) => a.position - b.position);
var insertAutomationStep = (workflow, parentId, step, position = 0) => {
  assertValidWorkflowStructure(workflow);
  if (workflow.steps.some((item) => item.id === step.id))
    throw new Error("Step identity already exists.");
  if (!workflow.steps.some((item) => item.id === parentId))
    throw new Error("Parent step does not exist.");
  if (step.type === "trigger") throw new Error("Triggers can only be the root.");
  const result = cloneAutomationWorkflow(workflow);
  for (const child of getChildrenInExecutionOrder(result, parentId).filter(
    (child2) => child2.position === position
  )) {
    child.parentId = step.id;
    child.position = 0;
  }
  result.steps.push({ ...JSON.parse(JSON.stringify(step)), parentId, position });
  assertValidWorkflowStructure(result);
  return result;
};
var deleteAutomationStep = (workflow, stepId) => {
  assertValidWorkflowStructure(workflow);
  const result = cloneAutomationWorkflow(workflow);
  const step = result.steps.find((item) => item.id === stepId);
  if (!step) throw new Error("Step does not exist.");
  if (step.id === result.rootStepId) throw new Error("The starting trigger cannot be deleted.");
  if (step.type === "condition") {
    const removed = /* @__PURE__ */ new Set([step.id]);
    const collectDescendantStepIds = (parentId) => {
      for (const child of getChildrenInExecutionOrder(result, parentId)) {
        removed.add(child.id);
        collectDescendantStepIds(child.id);
      }
    };
    collectDescendantStepIds(step.id);
    result.steps = result.steps.filter((item) => !removed.has(item.id));
  } else {
    for (const child of getChildrenInExecutionOrder(result, step.id)) {
      child.parentId = step.parentId;
      child.position = step.position;
    }
    result.steps = result.steps.filter((item) => item.id !== stepId);
  }
  assertValidWorkflowStructure(result);
  return result;
};
var reparentAutomationStep = (workflow, stepId, parentId, position = 0) => {
  assertValidWorkflowStructure(workflow);
  if (!Number.isSafeInteger(position) || position < 0) throw new Error("Invalid sibling position.");
  const result = cloneAutomationWorkflow(workflow);
  const step = result.steps.find((item) => item.id === stepId);
  if (!step || !result.steps.some((item) => item.id === parentId))
    throw new Error("Step or parent does not exist.");
  if (step.id === result.rootStepId) throw new Error("The root cannot be reparented.");
  const parent = result.steps.find((item) => item.id === parentId);
  if (parent.type === "condition" ? position > 1 : position !== 0)
    throw new Error("Invalid branch position.");
  if (result.steps.some(
    (item) => item.id !== stepId && item.parentId === parentId && item.position === position
  )) {
    throw new Error("The destination already has a successor.");
  }
  step.parentId = parentId;
  step.position = position;
  assertValidWorkflowStructure(result);
  return result;
};
var duplicateAutomationWorkflow = (workflow, createId, automationId) => {
  assertValidWorkflowStructure(workflow);
  const result = cloneAutomationWorkflow(workflow);
  const identities = new Map(result.steps.map((step) => [step.id, createId(step.id)]));
  const existing = new Set(workflow.steps.map((step) => step.id));
  if (new Set(identities.values()).size !== identities.size || [...identities.values()].some((id) => !id || existing.has(id))) {
    throw new Error("Duplicated steps require new, unique identities.");
  }
  result.rootStepId = workflow.rootStepId === null ? null : identities.get(workflow.rootStepId);
  for (const step of result.steps) {
    step.id = identities.get(step.id);
    step.parentId = step.parentId === null ? null : identities.get(step.parentId);
    delete step.automationId;
    if (automationId) step.automationId = automationId;
  }
  assertValidWorkflowStructure(result);
  return result;
};

// src/utils/certificate.ts
var DEFAULT_CERTIFICATE_FONT_COLOR = "#000000";
var defaultCertificateRenderTheme = {
  titleColor: DEFAULT_CERTIFICATE_FONT_COLOR,
  certifyTextColor: DEFAULT_CERTIFICATE_FONT_COLOR,
  nameColor: DEFAULT_CERTIFICATE_FONT_COLOR,
  courseNameColor: DEFAULT_CERTIFICATE_FONT_COLOR,
  bodyTextColor: DEFAULT_CERTIFICATE_FONT_COLOR,
  labelTextColor: DEFAULT_CERTIFICATE_FONT_COLOR,
  lineColor: "#9ca3af",
  logoColor: DEFAULT_CERTIFICATE_FONT_COLOR
};
var CERTIFICATE_KIND = {
  COURSE: "course",
  LEARNING_PATH: "learningPath"
};
var certificateTranslations = {
  pl: {
    certificate: "CERTYFIKAT",
    courseCompletion: "UKO\u0143CZENIA KURSU",
    certifyThat: "NINIEJSZYM ZA\u015AWIADCZA SI\u0118, \u017BE",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "uko\u0144czy\u0142/a kurs",
      [CERTIFICATE_KIND.LEARNING_PATH]: "uko\u0144czy\u0142/a \u015Bcie\u017Ck\u0119 rozwoju"
    },
    confirmation: "potwierdzaj\u0105c tym samym realizacj\u0119 programu szkoleniowego.",
    date: "Data",
    expiryDate: "Wygasa",
    signature: "Podpis"
  },
  en: {
    certificate: "CERTIFICATE",
    courseCompletion: "OF COURSE COMPLETION",
    certifyThat: "THIS IS TO CERTIFY THAT",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "has successfully completed the course",
      [CERTIFICATE_KIND.LEARNING_PATH]: "has successfully completed the development path"
    },
    confirmation: "thereby confirming participation in the full training program.",
    date: "Date",
    expiryDate: "Expires",
    signature: "Signature"
  },
  de: {
    certificate: "ZERTIFIKAT",
    courseCompletion: "KURSABSCHLUSS",
    certifyThat: "HIERMIT WIRD BEST\xC4TIGT, DASS",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "hat den Kurs erfolgreich abgeschlossen",
      [CERTIFICATE_KIND.LEARNING_PATH]: "hat den Entwicklungspfad erfolgreich abgeschlossen"
    },
    confirmation: "und best\xE4tigt damit die Teilnahme am gesamten Schulungsprogramm.",
    date: "Datum",
    expiryDate: "L\xE4uft ab",
    signature: "Unterschrift"
  },
  lt: {
    certificate: "SERTIFIKATAS",
    courseCompletion: "KURSO PABAIGOS",
    certifyThat: "\u0160IUO PATVIRTINAMA, KAD",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "s\u0117kmingai baig\u0117 kurs\u0105",
      [CERTIFICATE_KIND.LEARNING_PATH]: "s\u0117kmingai baig\u0117 tobul\u0117jimo keli\u0105"
    },
    confirmation: "taip patvirtindamas dalyvavim\u0105 visoje mokymo programoje.",
    date: "Data",
    expiryDate: "Galioja iki",
    signature: "Para\u0161as"
  },
  cs: {
    certificate: "CERTIFIK\xC1T",
    courseCompletion: "UKON\u010CEN\xCD KURZU",
    certifyThat: "T\xCDMTO SE POTVRZUJE, \u017DE",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "\xFAsp\u011B\u0161n\u011B absolvoval/a kurz",
      [CERTIFICATE_KIND.LEARNING_PATH]: "\xFAsp\u011B\u0161n\u011B dokon\u010Dil/a rozvojovou cestu"
    },
    confirmation: "\u010D\xEDm\u017E potvrzuje \xFA\u010Dast na cel\xE9m \u0161kolic\xEDm programu.",
    date: "Datum",
    expiryDate: "Plat\xED do",
    signature: "Podpis"
  },
  es: {
    certificate: "CERTIFICADO",
    courseCompletion: "DE FINALIZACI\xD3N DEL CURSO",
    certifyThat: "SE CERTIFICA QUE",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "ha completado correctamente el curso",
      [CERTIFICATE_KIND.LEARNING_PATH]: "ha completado correctamente la ruta de desarrollo"
    },
    confirmation: "confirmando as\xED su participaci\xF3n en todo el programa formativo.",
    date: "Fecha",
    expiryDate: "Caduca",
    signature: "Firma"
  },
  fr: {
    certificate: "CERTIFICAT",
    courseCompletion: "DE R\xC9USSITE DU COURS",
    certifyThat: "CECI CERTIFIE QUE",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "a termin\xE9 avec succ\xE8s le cours",
      [CERTIFICATE_KIND.LEARNING_PATH]: "a termin\xE9 avec succ\xE8s le parcours de d\xE9veloppement"
    },
    confirmation: "confirmant ainsi sa participation \xE0 l'ensemble du programme de formation.",
    date: "Date",
    expiryDate: "Expire le",
    signature: "Signature"
  }
};
function buildCertificateMarkup(options) {
  const {
    studentName = "",
    courseName = "",
    completionDate = "",
    expiryDate = "",
    platformLogoUrl,
    signatureImageUrl,
    backgroundImageUrl,
    lang = "en",
    colorTheme = defaultCertificateRenderTheme,
    isDownload = false,
    certificateKind = CERTIFICATE_KIND.COURSE
  } = options;
  const t = certificateTranslations[lang];
  const backgroundStyle = [
    backgroundImageUrl ? `background-image:url(${escapeCssUrl(backgroundImageUrl)});background-size:100% 100%;background-position:center;background-repeat:no-repeat;` : "background-color:white;"
  ].join("");
  const logoMarkup = platformLogoUrl ? `<img src="${escapeHtml(platformLogoUrl)}" alt="Platform Logo" class="aspect-auto h-11" />` : `<div class="h-11" style="color:${escapeHtml(colorTheme.logoColor)};">${APP_LOGO_SVG}</div>`;
  const signatureImageMarkup = signatureImageUrl ? `<img src="${escapeHtml(signatureImageUrl)}" alt="${escapeHtml(t.signature)}" class="mb-2 h-20 w-full object-contain" style="display:block;margin-bottom:8px;height:5rem;width:100%;object-fit:contain;" />` : '<div class="mb-2 h-20 w-full" aria-hidden="true" style="margin-bottom:8px;height:5rem;width:100%;"></div>';
  const footerGapClass = expiryDate ? "gap-x-16" : "gap-x-52";
  const expiryDateMarkup = expiryDate ? `<div class="flex w-[280px] flex-col items-center">
        <p
          class="text-[18px] text-gray-600"
          style="color:${escapeHtml(colorTheme.bodyTextColor)};"
        >
          ${escapeHtml(expiryDate)}
        </p>
        <hr
          class="mx-auto mb-3 w-full"
          style="border-color:${escapeHtml(colorTheme.lineColor)};"
        />
        <p
          class="text-[18px] uppercase text-gray-800"
          style="color:${escapeHtml(colorTheme.labelTextColor)};"
        >
          ${escapeHtml(t.expiryDate)}
        </p>
      </div>` : "";
  const certificateBodyMarkup = `<div
    class="flex h-full w-full flex-col items-center justify-center gap-y-12 px-14 py-12"
    style="${backgroundStyle}"
  >
    ${logoMarkup}
    <div class="flex flex-col items-center justify-center gap-y-4">
      <p
        class="text-[62px] font-black uppercase tracking-wider"
        style="color:${escapeHtml(colorTheme.titleColor)};"
      >
        ${escapeHtml(t.certificate)}
      </p>
      <p
        class="text-[17px] font-semibold uppercase tracking-[0.2em]"
        style="color:${escapeHtml(colorTheme.certifyTextColor)};"
      >
        ${escapeHtml(t.certifyThat)}
      </p>
    </div>

    <div class="flex flex-col items-center justify-center">
      <p
        class="mb-4 text-[44px] tracking-wider"
        style="color:${escapeHtml(colorTheme.nameColor)};"
      >
        ${escapeHtml(studentName)}
      </p>
      <p
        class="text-[18px] text-gray-600"
        style="color:${escapeHtml(colorTheme.bodyTextColor)};"
      >
        ${escapeHtml(t.successfulCompletion[certificateKind])}
      </p>
      <p
        class="text-[24px]"
        style="color:${escapeHtml(colorTheme.courseNameColor)};"
      >
        "${escapeHtml(courseName)}"
      </p>
      <p
        class="text-[18px] text-gray-600"
        style="color:${escapeHtml(colorTheme.bodyTextColor)};"
      >
        ${escapeHtml(t.confirmation)}
      </p>
    </div>

    <div class="flex items-end ${footerGapClass}">
      <div class="flex w-[280px] flex-col items-center">
        <p
          class="text-[18px] text-gray-600"
          style="color:${escapeHtml(colorTheme.bodyTextColor)};"
        >
          ${escapeHtml(completionDate)}
        </p>
        <hr
          class="mx-auto mb-3 w-full"
          style="border-color:${escapeHtml(colorTheme.lineColor)};"
        />
        <p
          class="text-[18px] uppercase text-gray-800"
          style="color:${escapeHtml(colorTheme.labelTextColor)};"
        >
          ${escapeHtml(t.date)}
        </p>
      </div>

      ${expiryDateMarkup}

      <div class="flex w-[280px] flex-col items-center">
        ${signatureImageMarkup}
        <hr
          class="mx-auto mb-3 w-full"
          style="border-color:${escapeHtml(colorTheme.lineColor)};"
        />
        <p
          class="text-[18px] uppercase text-gray-800"
          style="color:${escapeHtml(colorTheme.labelTextColor)};"
        >
          ${escapeHtml(t.signature)}
        </p>
      </div>
    </div>
  </div>`;
  if (!isDownload) return certificateBodyMarkup;
  return `<div class="mx-auto h-[210mm] w-[297mm] overflow-hidden">${certificateBodyMarkup}</div>`;
}
function buildCertificateHtmlDocument(html, options) {
  const baseTag = buildBaseTag(options?.baseUrl);
  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    ${baseTag}
    <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      html, body {
        width: 297mm;
        height: 210mm;
        overflow: hidden;
        background-color: white;
      }
      body > * {
        width: 297mm;
        height: 210mm;
        transform-origin: top left;
      }
    </style>
    <title>Certificate</title>
    <script src="https://cdn.jsdelivr.net/npm/@tailwindcss/browser@4"></script>
  </head>
  <body>
    ${html}
  </body>
</html>`;
}
function buildBaseTag(baseUrl) {
  if (!baseUrl) return "";
  return `<base href="${escapeHtml(baseUrl)}" />`;
}
var APP_LOGO_SVG = `<svg viewBox="0 0 366 80" fill="none" xmlns="http://www.w3.org/2000/svg" style="height:100%;width:auto;display:block;"><path d="M41.2045 26.686C35.1989 26.686 30.3109 29.4993 28.0114 34.914C25.6412 29.5058 20.7468 26.686 14.8182 26.686C6.37177 26.686 0 31.9465 0 42.84V64.2546H4.9651V42.84C4.9651 35.0617 9.26219 31.2785 15.1908 31.2785C21.1193 31.2785 25.5641 35.203 25.5641 42.84V64.2546H30.5292V42.84C30.5292 35.2094 34.9034 31.2785 40.832 31.2785C46.7606 31.2785 51.0576 35.0553 51.0576 42.84V64.2546H56.0227V42.84C56.0227 31.9465 49.651 26.686 41.2045 26.686Z" fill="#292929"/><path d="M73.7249 29.2379C63.7112 35.0187 60.7308 46.1498 66.2868 55.7844C71.8429 65.4126 82.9806 68.3994 92.9943 62.6186C100.375 58.3537 103.927 51.1727 102.995 43.921L98.3127 46.6252C98.3705 51.4682 95.7113 55.7459 90.7013 58.6363C83.578 62.7471 75.9344 60.9165 71.541 54.6411L101.126 37.5558L100.31 36.1427C94.7543 26.5145 83.745 23.4571 73.7313 29.2379H73.7249ZM69.4342 50.7038C66.8007 43.921 69.4085 37.0291 76.0243 33.2074C82.6402 29.3856 89.6735 30.4583 94.401 36.2904L69.4342 50.7038Z" fill="#292929"/><path d="M128.649 26.686C117.833 26.686 110.568 32.9871 110.568 45.1395V64.261H115.533V45.1395C115.533 36.0958 120.723 31.285 128.649 31.285C136.575 31.285 141.765 36.1023 141.765 45.1395V64.261H146.73V45.1395C146.73 32.9871 139.466 26.686 128.649 26.686Z" fill="#292929"/><path d="M179.63 50.7748C179.63 57.5191 175.853 60.6278 170.22 60.6278C164.587 60.6278 160.81 57.442 160.81 50.7748V32.1736H182.372V27.6518H160.81V14.6836H155.845V50.7748C155.845 60.4094 161.696 65.2267 170.22 65.2267C178.743 65.2267 184.447 60.4094 184.447 50.7748V49.9591H179.63V50.7748Z" fill="#292929"/><path d="M227.431 26.686C216.614 26.686 209.35 32.9871 209.35 45.1395V64.261H214.315V45.1395C214.315 36.0958 219.505 31.285 227.431 31.285C235.357 31.285 240.547 36.1023 240.547 45.1395V64.261H245.512V45.1395C245.512 32.9871 238.247 26.686 227.431 26.686Z" fill="#292929"/><path d="M319.841 26.686C308.279 26.686 300.128 34.8369 300.128 45.9552C300.128 57.0736 308.279 65.2245 319.841 65.2245C331.403 65.2245 339.553 57.0736 339.553 45.9552C339.553 34.8369 331.403 26.686 319.841 26.686ZM319.841 60.6255C311.099 60.6255 305.17 54.4016 305.17 45.9552C305.17 37.5089 311.099 31.285 319.841 31.285C328.583 31.285 334.511 37.5089 334.511 45.9552C334.511 54.4016 328.583 60.6255 319.841 60.6255Z" fill="#292929"/><path d="M272.817 26.686C261.255 26.686 253.104 34.8369 253.104 45.9552C253.104 57.0736 261.255 65.2245 272.817 65.2245C284.379 65.2245 292.53 57.0736 292.53 45.9552C292.53 34.8369 284.379 26.686 272.817 26.686ZM272.817 60.6255C264.075 60.6255 258.146 54.4016 258.146 45.9552C258.146 37.5089 264.075 31.285 272.817 31.285C281.559 31.285 287.487 37.5089 287.487 45.9552C287.487 54.4016 281.559 60.6255 272.817 60.6255Z" fill="#292929"/><path d="M272.817 75.034C267.852 75.034 263.234 73.5374 259.393 70.9746L256.643 75.1111C261.275 78.2006 266.837 79.999 272.817 79.999C278.797 79.999 284.359 78.1941 288.99 75.1111L286.241 70.9746C282.4 73.5374 277.782 75.034 272.817 75.034Z" fill="#292929"/><path d="M192.598 26.6894C192.598 24.5376 194.23 22.9126 196.375 22.9126C198.521 22.9126 200.152 24.5441 200.152 26.6894C200.152 28.8347 198.521 30.4661 196.375 30.4661C194.23 30.4661 192.598 28.8347 192.598 26.6894Z" fill="#292929"/><path d="M196.381 36.8942C195.534 36.8942 194.718 36.785 193.934 36.5988V64.2694H198.899V36.5859C198.096 36.7851 197.255 36.9007 196.381 36.9007V36.8942Z" fill="#292929"/><path d="M272.823 31.2612V26.6944H290.16C290.16 29.2187 288.111 31.2612 285.593 31.2612H272.823Z" fill="#292929"/><path d="M350.993 34.3951C350.993 25.9488 356.922 19.7248 365.664 19.7248V15.1323C354.102 15.1323 345.951 23.2832 345.951 34.4015H350.993V34.3951Z" fill="#4796FD"/><path d="M331.223 19.7257C339.669 19.7257 345.893 25.6542 345.893 34.396H350.486C350.486 22.8345 342.335 14.6836 331.216 14.6836V19.7257H331.223Z" fill="#4796FD"/><path d="M365.664 14.6771C357.217 14.6771 350.993 8.74864 350.993 0.00683594H346.401C346.401 11.5684 354.551 19.7192 365.67 19.7192V14.6771H365.664Z" fill="#4796FD"/><path d="M345.893 0.00640974C345.893 8.45275 339.964 14.6767 331.222 14.6767V19.2692C342.784 19.2692 350.935 11.1183 350.935 0H345.893V0.00640974Z" fill="#4796FD"/></svg>`;
function escapeHtml(value) {
  return value.replace("&", "&amp;").replace("<", "&lt;").replace(">", "&gt;").replace('"', "&quot;").replace("'", "&#39;");
}
function escapeCssUrl(value) {
  return value.replace("\\", "\\\\").replace('"', '\\"').replace("\n", "");
}

// src/utils/courseAuthoringOrder.ts
var CourseAuthoringOrderError = class extends Error {
  constructor(code) {
    super(`courseAuthoring.errors.${code}`);
    this.code = code;
    this.name = "CourseAuthoringOrderError";
  }
};
var orderCourseAuthoringOperations = (operations) => {
  const ids = new Set(operations.map((operation) => operation.operationId));
  if (ids.size !== operations.length) throw new CourseAuthoringOrderError("duplicateOperation");
  if (operations.some((operation) => operation.dependencies.some((id) => !ids.has(id))))
    throw new CourseAuthoringOrderError("missingDependency");
  const pending = [...operations];
  const completed = /* @__PURE__ */ new Set();
  const ordered = [];
  while (pending.length) {
    const index = pending.findIndex(
      (operation2) => operation2.dependencies.every((id) => completed.has(id))
    );
    if (index < 0) throw new CourseAuthoringOrderError("dependencyCycle");
    const [operation] = pending.splice(index, 1);
    completed.add(operation.operationId);
    ordered.push(operation);
  }
  return ordered;
};
var groupKey = (group) => group.kind === "chapter" ? "chapters" : `lessons:${group.chapterId}`;
var payloadFields = (payload) => payload && typeof payload === "object" && !Array.isArray(payload) ? payload : {};
var placeBatch = (ids, positions) => {
  const requested = [...positions.entries()].sort(([, left], [, right]) => left - right);
  if (!requested.length) return [...ids];
  const slots = [];
  let ceiling = ids.length;
  for (let index = requested.length - 1; index >= 0; index--) {
    slots[index] = Math.min(requested[index][1], ceiling - 1);
    ceiling = slots[index];
  }
  const result = Array.from({ length: ids.length });
  let previous = -1;
  requested.forEach(([id], index) => {
    const slot = Math.max(slots[index], previous + 1);
    result[slot] = id;
    previous = slot;
  });
  const untouched = ids.filter((id) => !positions.has(id));
  let next = 0;
  return result.map((id) => id ?? untouched[next++]);
};
var planCourseAuthoringOrder = (currentGroups, operations) => {
  const groups = /* @__PURE__ */ new Map();
  const original = /* @__PURE__ */ new Map();
  for (const group of currentGroups) {
    const key = groupKey(group);
    if (groups.has(key) || new Set(group.orderedIds).size !== group.orderedIds.length)
      throw new CourseAuthoringOrderError("invalidOperations");
    original.set(key, group.orderedIds);
    groups.set(key, { ...group, orderedIds: [...group.orderedIds] });
  }
  const pending = /* @__PURE__ */ new Map();
  const ordered = orderCourseAuthoringOperations(operations);
  const deleted = new Set(
    ordered.filter(
      (operation) => operation.type === "chapter.delete" || operation.type === "lesson.delete"
    ).map((operation) => operation.targetId)
  );
  const flush = (key) => {
    const group = groups.get(key);
    const positions = pending.get(key);
    if (group && positions) group.orderedIds = placeBatch(group.orderedIds, positions);
    pending.delete(key);
  };
  for (const operation of ordered) {
    if (deleted.has(operation.targetId)) continue;
    let key;
    let position;
    switch (operation.type) {
      case "chapter.create":
      case "chapter.update":
        key = "chapters";
        position = payloadFields(operation.payload).displayOrder;
        break;
      case "lesson.create":
      case "lesson.update":
        if (operation.displayOrder === void 0 || deleted.has(operation.chapterId ?? ""))
          continue;
        key = `lessons:${operation.chapterId}`;
        position = operation.displayOrder;
        break;
      case "chapter.reorder":
      case "lesson.reorder": {
        key = operation.type === "chapter.reorder" ? "chapters" : `lessons:${operation.targetId}`;
        flush(key);
        const group2 = groups.get(key);
        const ids = payloadFields(operation.payload).orderedIds;
        if (!group2 || !Array.isArray(ids) || ids.some((id) => typeof id !== "string") || new Set(ids).size !== ids.length)
          throw new CourseAuthoringOrderError("invalidReorder");
        const surviving = ids.filter((id) => !deleted.has(id));
        if (surviving.some((id) => !group2.orderedIds.includes(id)))
          throw new CourseAuthoringOrderError("targetOutsideCourse");
        group2.orderedIds = [
          ...surviving,
          ...group2.orderedIds.filter((id) => !surviving.includes(id))
        ];
        continue;
      }
      default:
        continue;
    }
    if (typeof position !== "number" || !Number.isSafeInteger(position) || position < 0)
      throw new CourseAuthoringOrderError("invalidOperations");
    const group = groups.get(key);
    if (!group || !group.orderedIds.includes(operation.targetId))
      throw new CourseAuthoringOrderError("targetOutsideCourse");
    const positions = pending.get(key) ?? /* @__PURE__ */ new Map();
    positions.delete(operation.targetId);
    positions.set(operation.targetId, position);
    pending.set(key, positions);
  }
  for (const key of pending.keys()) flush(key);
  return [...groups.entries()].filter(
    ([key, group]) => group.orderedIds.some((id, index) => id !== original.get(key)?.[index])
  ).map(([, group]) => group);
};

// src/utils/emailTemplateLayout.ts
function getEmailTemplateLayoutSections(blocks) {
  let footerStartIndex = blocks.length;
  while (footerStartIndex > 0 && blocks[footerStartIndex - 1].type === "footer") {
    footerStartIndex -= 1;
  }
  let headerEndIndex = 0;
  while (headerEndIndex < footerStartIndex && (blocks[headerEndIndex].type === "header" || blocks[headerEndIndex].type === "heading")) {
    headerEndIndex += 1;
  }
  return { headerEndIndex, footerStartIndex };
}
var getEmailCardBackground = (primaryColor) => `linear-gradient(to bottom, ${primaryColor} 0%, ${primaryColor} 50%, #fafafa 50%, #fafafa 100%)`;

// src/utils/normalizeAuthoringQuizQuestionOrder.ts
var normalizeAuthoringQuizQuestionOrder = (questions) => [...questions].sort((left, right) => left.displayOrder - right.displayOrder).map((question, index) => ({ ...question, displayOrder: index + 1 }));

// src/utils/permissions.ts
var hasPermission = (permissions, permission) => {
  if (!permissions?.length) return false;
  return permissions.includes(permission);
};
var hasAnyPermission = (permissions, requiredPermissions) => {
  if (!requiredPermissions.length) return true;
  if (!permissions?.length) return false;
  return requiredPermissions.some((permission) => permissions.includes(permission));
};
var hasAllPermissions = (permissions, requiredPermissions) => {
  if (!requiredPermissions.length) return true;
  if (!permissions?.length) return false;
  return requiredPermissions.every((permission) => permissions.includes(permission));
};
var matchesRequirement = (permissions, requirement) => {
  if (!requirement) return true;
  const { anyOf = [], allOf = [] } = requirement;
  return hasAnyPermission(permissions, anyOf) && hasAllPermissions(permissions, allOf);
};

// src/utils/sanitizeRichTextSummary.ts
import sanitizeHtml from "sanitize-html";
var sanitizeRichTextSummary = (content) => sanitizeHtml(content, {
  allowedTags: [
    "p",
    "br",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "sub",
    "sup",
    "code",
    "span",
    "ul",
    "ol",
    "li"
  ],
  allowedAttributes: {},
  nonTextTags: ["script", "style", "textarea", "option", "svg", "math"]
});

// src/utils/sanitizeQuizQuestionTitle.ts
var sanitizeQuizQuestionTitle = (title) => sanitizeRichTextSummary(title);

// src/utils/uiMessage.ts
var getUiMessageText = (message) => {
  if (!message || !Array.isArray(message.parts)) {
    return "";
  }
  return message.parts.map((part) => {
    const textPart = part;
    return textPart.type === "text" && typeof textPart.text === "string" ? textPart.text : "";
  }).join("");
};
var toUiMessageRole = (role) => {
  return role === "assistant" || role === "system" ? role : "user";
};
var createTextUiMessage = ({
  id,
  role,
  content
}) => ({
  id,
  role,
  parts: [{ type: "text", text: content }]
});

// src/utils/videoCoverage.ts
var isVideoCoverageRange = (value) => Array.isArray(value) && value.length === 2 && Number.isFinite(value[0]) && Number.isFinite(value[1]) && value[1] > value[0];
var parseVideoCoverageRanges = (value) => {
  if (Array.isArray(value)) {
    return value.filter(isVideoCoverageRange);
  }
  if (!value) return [];
  try {
    const parsedValue = JSON.parse(value);
    return Array.isArray(parsedValue) ? parsedValue.filter(isVideoCoverageRange) : [];
  } catch {
    return [];
  }
};
var mergeVideoCoverageRanges = (ranges) => {
  const sortedRanges = ranges.filter(isVideoCoverageRange).map(([start, end]) => [Math.max(0, start), Math.max(0, end)]).filter(isVideoCoverageRange).sort(([startA, endA], [startB, endB]) => {
    if (startA !== startB) return startA - startB;
    return endA - endB;
  });
  const mergedRanges = [];
  for (const [start, end] of sortedRanges) {
    const previous = mergedRanges.at(-1);
    if (!previous || start > previous[1]) {
      mergedRanges.push([start, end]);
      continue;
    }
    mergedRanges[mergedRanges.length - 1] = [previous[0], Math.max(previous[1], end)];
  }
  return mergedRanges;
};
var countVideoCoverageRangeUnits = (ranges) => ranges.reduce((total, [start, end]) => total + Math.max(0, end - start), 0);
var getVideoCoverageMaxBucketCount = (durationSeconds, bucketSizeSeconds) => Math.max(1, Math.ceil(durationSeconds / bucketSizeSeconds));
var bucketizeVideoCoverageTimeRange = ({
  startSeconds,
  endSeconds,
  bucketSizeSeconds
}) => {
  const start = Math.floor(Math.min(startSeconds, endSeconds) / bucketSizeSeconds) * bucketSizeSeconds;
  const end = Math.ceil(Math.max(startSeconds, endSeconds) / bucketSizeSeconds) * bucketSizeSeconds;
  if (end <= start) return null;
  return [start, end];
};
var toVideoCoverageBucketRanges = ({
  watchedRanges,
  durationSeconds,
  bucketSizeSeconds
}) => {
  const maxBucketCount = getVideoCoverageMaxBucketCount(durationSeconds, bucketSizeSeconds);
  return watchedRanges.map(([startSeconds, endSeconds]) => {
    const startBucket = Math.max(0, Math.floor(startSeconds / bucketSizeSeconds));
    const endBucket = Math.min(maxBucketCount, Math.ceil(endSeconds / bucketSizeSeconds));
    return [startBucket, endBucket];
  }).filter(([startBucket, endBucket]) => endBucket > startBucket);
};

// src/utils/videoUrls.ts
var UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;
var tryParseUrl = (input) => {
  try {
    return new URL(input);
  } catch {
    try {
      return new URL(input, "http://localhost");
    } catch {
      return null;
    }
  }
};
var extractYoutubeId = (url) => {
  if (url.hostname === "youtu.be") {
    return url.pathname.replace("/", "").split("/")[0] || null;
  }
  if (url.pathname === "/watch") {
    return url.searchParams.get("v");
  }
  const pathParts = url.pathname.split("/").filter(Boolean);
  const embedIndex = pathParts.findIndex((part) => part === "embed" || part === "shorts");
  if (embedIndex !== -1 && pathParts[embedIndex + 1]) {
    return pathParts[embedIndex + 1];
  }
  return null;
};
var extractVimeoId = (url) => {
  const pathParts = url.pathname.split("/").filter(Boolean);
  const lastPart = pathParts[pathParts.length - 1];
  if (!lastPart) return null;
  return /^\d+$/.test(lastPart) ? lastPart : null;
};
var extractBunnyId = (sourceUrl, url) => {
  if (sourceUrl.startsWith("bunny-")) return sourceUrl.replace("bunny-", "");
  if (!url) return null;
  const pathParts = url.pathname.split("/").filter(Boolean);
  if (url.hostname === "iframe.mediadelivery.net") {
    const embedIndex = pathParts.findIndex((part) => part === "embed");
    if (embedIndex !== -1 && pathParts[embedIndex + 2]) {
      return pathParts[embedIndex + 2];
    }
  }
  const uuidSegment = pathParts.find((part) => UUID_REGEX.test(part));
  if (uuidSegment) return uuidSegment.match(UUID_REGEX)?.[0] ?? null;
  if (pathParts.length >= 2 && pathParts[pathParts.length - 1].endsWith(".jpg")) {
    return pathParts[pathParts.length - 2] ?? null;
  }
  return pathParts[pathParts.length - 1] ?? null;
};
var detectVideoProviderFromUrl = (sourceUrl) => {
  if (sourceUrl.startsWith("bunny-")) return VIDEO_EMBED_PROVIDERS.BUNNY;
  const url = tryParseUrl(sourceUrl);
  if (!url) return VIDEO_EMBED_PROVIDERS.UNKNOWN;
  if (extractResourceIdFromSourceUrl(sourceUrl)) {
    return VIDEO_EMBED_PROVIDERS.SELF;
  }
  const host = url.hostname.toLowerCase();
  if (host === "youtu.be" || host.endsWith("youtube.com")) return VIDEO_EMBED_PROVIDERS.YOUTUBE;
  if (host.endsWith("vimeo.com")) return VIDEO_EMBED_PROVIDERS.VIMEO;
  if (host.endsWith("bunny.net") || host.endsWith("bunnycdn.com") || host.includes("b-cdn") || host.includes("mediadelivery")) {
    return VIDEO_EMBED_PROVIDERS.BUNNY;
  }
  return VIDEO_EMBED_PROVIDERS.UNKNOWN;
};
var extractVideoIdFromSourceUrl = (sourceUrl, provider) => {
  const url = tryParseUrl(sourceUrl);
  switch (provider) {
    case VIDEO_EMBED_PROVIDERS.YOUTUBE:
      return url ? extractYoutubeId(url) : null;
    case VIDEO_EMBED_PROVIDERS.VIMEO:
      return url ? extractVimeoId(url) : null;
    case VIDEO_EMBED_PROVIDERS.BUNNY:
      return extractBunnyId(sourceUrl, url);
    default:
      return null;
  }
};
var extractResourceIdFromSourceUrl = (sourceUrl) => {
  if (UUID_REGEX.test(sourceUrl)) return sourceUrl.match(UUID_REGEX)?.[0] ?? null;
  const url = tryParseUrl(sourceUrl);
  if (!url) return null;
  const match = url.pathname.match(/\/(?:lesson|articles|news)-resource\/([0-9a-f-]{36})/i);
  if (match?.[1]) return match[1];
  const pathParts = url.pathname.split("/").filter(Boolean);
  const lastPart = pathParts[pathParts.length - 1];
  if (lastPart && UUID_REGEX.test(lastPart)) return lastPart;
  return null;
};
export {
  ACCESS_GUARD,
  ACCOUNT_ACTION_KINDS,
  ACTIVITY_LOG_ACTION_TYPES,
  ACTIVITY_LOG_RESOURCE_ACTION_TYPES,
  ACTIVITY_LOG_RESOURCE_TYPES,
  AI_JUDGE_CONFIGURATION_GENERATION_SOCKET_EVENTS,
  AI_JUDGE_DRAFT_CHANGE_FIELD,
  AI_JUDGE_DRAFT_CHANGE_TYPE,
  AI_JUDGE_GENERATION_MAX_ATTEMPTS,
  AI_JUDGE_GENERATION_MODE,
  AI_JUDGE_GENERATION_STATUS,
  AI_JUDGE_MAX_CRITERION_SCORE,
  AI_JUDGE_VALIDATION_SEVERITY,
  AI_JUDGE_VALIDATION_TARGET,
  AI_MENTOR_CONFIGURATION_DRAFT_CHANGE_TYPE,
  AI_MENTOR_CONFIGURATION_FIELD,
  AI_MENTOR_CONFIGURATION_GENERATION_MAX_ATTEMPTS,
  AI_MENTOR_CONFIGURATION_GENERATION_MODE,
  AI_MENTOR_CONFIGURATION_GENERATION_SOCKET_EVENTS,
  AI_MENTOR_CONFIGURATION_GENERATION_STATUS,
  AI_MENTOR_CONFIGURATION_VALIDATION_SEVERITY,
  AI_MENTOR_PRACTICE_ERROR_CODES,
  AI_MENTOR_PRACTICE_STATUSES,
  AI_MENTOR_ROLEPLAY_DIFFICULTY,
  AI_MENTOR_TEACHING_STYLE,
  AI_MENTOR_TTS_PRESET,
  AI_MENTOR_TYPE,
  AI_MENTOR_VOICE_MODE,
  AI_THREAD_STATUSES,
  AI_THREAD_TYPES,
  ALLOWED_AGE_LIMITS,
  ALLOWED_ARTICLES_SETTINGS,
  ALLOWED_AVATAR_IMAGE_TYPES,
  ALLOWED_CERTIFICATE_SIGNATURE_FILE_TYPES,
  ALLOWED_EXCEL_FILE_TYPES,
  ALLOWED_EXTENSIONS,
  ALLOWED_LESSON_IMAGE_FILE_TYPES,
  ALLOWED_NEWS_SETTINGS,
  ALLOWED_PDF_FILE_TYPES,
  ALLOWED_PRESENTATION_FILE_TYPES,
  ALLOWED_QA_SETTINGS,
  ALLOWED_VIDEO_FILE_TYPES,
  ALLOWED_WORD_FILE_TYPES,
  ANNOUNCEMENT_AUDIENCES,
  ANNOUNCEMENT_EMAIL_TEMPLATES,
  ANNOUNCEMENT_FEEDS,
  ANNOUNCEMENT_SOURCE_TYPES,
  ANNOUNCEMENT_STATUSES,
  ARTICLE_STATUS,
  ASSESSMENT_ANSWER_GRADING_STATUSES,
  ASSESSMENT_ATTEMPT_GRADING_STATUSES,
  ASSESSMENT_ATTEMPT_LIMIT_MODES,
  ASSESSMENT_ATTEMPT_RESULTS,
  ASSESSMENT_ATTEMPT_SUBMISSION_STATUSES,
  ASSESSMENT_FEEDBACK_MODES,
  ASSESSMENT_GRADING_MODES,
  ASSESSMENT_QUESTION_TYPES,
  ASSESSMENT_TEXT_COMPARISON_MODES,
  AUTOMATION_BRANCH_FIELD_AVAILABILITY,
  AUTOMATION_CONDITION_BRANCH_POSITIONS,
  AUTOMATION_DEFINITION_KINDS,
  AUTOMATION_EMAIL_BRANCH_PLANS,
  AUTOMATION_EMAIL_DELIVERY_STATUSES,
  AUTOMATION_EVENT_KINDS,
  AUTOMATION_EVENT_VARIABLES,
  AUTOMATION_FIELD_SENSITIVITIES,
  AUTOMATION_MAPPING_TYPES,
  AUTOMATION_MAX_EMAIL_DELIVERY_ATTEMPTS,
  AUTOMATION_NODE_KINDS,
  AUTOMATION_PLACEHOLDER_TYPES,
  AUTOMATION_RECIPIENT_TYPES,
  AUTOMATION_RESERVED_BRANDING_PLACEHOLDER,
  AUTOMATION_RUN_RETENTION_DAYS,
  AUTOMATION_RUN_STATUSES,
  AUTOMATION_STATUSES,
  AUTOMATION_STEP_TYPES,
  AUTOMATION_TEMPLATE_TYPES,
  AUTOMATION_TRIGGER_DEFINITIONS,
  AUTOMATION_VALIDATION_ISSUE_CODES,
  BUILT_IN_EMAIL_TEMPLATE_KEYS,
  CALENDAR_EVENT_SOURCE_ROLES,
  CALENDAR_EVENT_SOURCE_TYPES,
  CALENDAR_EVENT_STATUSES,
  CALENDAR_PROVIDERS,
  CERTIFICATE_ARCHIVE_REASONS,
  CERTIFICATE_KIND,
  CERTIFICATE_RESET_SCOPES,
  CERTIFICATE_STATUSES,
  CERTIFICATE_VALIDITY_TYPES,
  CERTIFICATE_VALIDITY_UNITS,
  CONTENT_MARKETPLACE_DURATIONS,
  CONTENT_MARKETPLACE_SORT,
  COURSE_ARCHIVED_QUERY_VALUES,
  COURSE_AUTHORING_SOURCE_FILE_TYPES,
  COURSE_CERTIFICATE_STATUSES,
  COURSE_CHAT_ALLOWED_REACTIONS,
  COURSE_CHAT_SOCKET_EVENTS,
  COURSE_DUPLICATION_SOCKET,
  COURSE_DUPLICATION_STATUS,
  COURSE_ENROLLMENT,
  COURSE_FEATURE,
  COURSE_FEATURE_ERROR_TRANSLATION_KEY,
  COURSE_GENERATION_SYNC_STATUS,
  COURSE_ORIGIN_TYPES,
  COURSE_PROGRESS_STATUSES,
  COURSE_STATUSES,
  COURSE_TYPE,
  COURSE_TYPE_DISABLED_FEATURES,
  CourseAuthoringOrderError,
  DASHBOARD_CALENDAR_VIEWS,
  DASHBOARD_DEADLINE_RISK_GROUP_SORT_FIELDS,
  DASHBOARD_DEADLINE_RISK_SORT_DIRECTIONS,
  DASHBOARD_DEADLINE_RISK_TYPES,
  DASHBOARD_DEADLINE_RISK_URGENCY_ORDERS,
  DASHBOARD_DEFAULT_LAYOUTS,
  DASHBOARD_SCHEMA_VERSION,
  DASHBOARD_WIDGET_CATALOG,
  DASHBOARD_WIDGET_SIZES,
  DASHBOARD_WIDGET_TYPES,
  DEFAULT_AI_MENTOR_TYPE,
  DEFAULT_CERTIFICATE_FONT_COLOR,
  DEFAULT_EMAIL_PRIMARY_COLOR,
  DEFAULT_LIVE_TRAINING_SETTINGS,
  DEFAULT_TUS_CHUNK_SIZE,
  DEFAULT_TUS_TTL_MS,
  EMAIL_LOGIN_METHODS,
  ENTITY_TYPES,
  FEATURES,
  FEATURE_SETTINGS_KEYS,
  FEATURE_UNREGISTERED_ACCESS_KEYS,
  FORM_FIELD_TYPES,
  FORM_TYPES,
  GLOBAL_SEARCH_MODES,
  GLOBAL_SEARCH_RESULT_TYPES,
  GLOBAL_SEARCH_SEMANTIC_STATUSES,
  HEX_COLOR_REGEX,
  LEARNER_PROGRESS_STATUSES,
  LEARNER_TRANSCRIPT_STATUSES,
  LEARNING_PATH_CERTIFICATE_STATUSES,
  LEARNING_PATH_ENROLLMENT_TYPES,
  LEARNING_PATH_ENTITY_TYPES,
  LEARNING_PATH_PROGRESS_STATUSES,
  LEARNING_PATH_STATUSES,
  LESSON_TYPES,
  LIVE_TRAINING_DELIVERY_TYPES,
  LIVE_TRAINING_DESCRIPTION_MAX_LENGTH,
  LIVE_TRAINING_LINK_ENTITY_TYPES,
  LIVE_TRAINING_MAX_PARTICIPANTS_LIMIT,
  LIVE_TRAINING_MEMBER_ROLES,
  LIVE_TRAINING_PARTICIPANT_ROLES,
  LIVE_TRAINING_RESOURCE_RELATIONSHIP_TYPES,
  LIVE_TRAINING_SESSION_STATUSES,
  LIVE_TRAINING_SOCKET_CLIENT_EVENTS,
  LIVE_TRAINING_SOCKET_ROOMS,
  LIVE_TRAINING_SOCKET_ROOM_BUILDERS,
  LIVE_TRAINING_SOCKET_SERVER_EVENTS,
  LIVE_TRAINING_STATUSES,
  LIVE_TRAINING_TITLE_MAX_LENGTH,
  LIVE_TRAINING_VISIBILITY_SCOPES,
  LOGIN_METHODS,
  LOGIN_METHOD_ERROR_KEYS,
  LOGIN_PAGE_DOCUMENTS_FILE_TYPES,
  LUMA_FILE_INGESTION_ALLOWED_EXTENSIONS,
  LUMA_FILE_INGESTION_ALLOWED_MIME_TYPES,
  LUMA_FILE_INGESTION_MAX_SIZE_BYTES,
  LUMA_FILE_INGESTION_MAX_SIZE_MB,
  MASTER_COURSE_ENTITY_TYPES,
  MASTER_COURSE_EXPORT_SYNC_STATUSES,
  MAX_COURSE_AUTHORING_SOURCE_SIZE,
  MAX_COURSE_LEARNING_OUTCOMES,
  MAX_COURSE_TRAILER_VIDEO_SIZE,
  MAX_COURSE_TRAILER_VIDEO_SIZE_MB,
  MAX_LOGIN_PAGE_DOCUMENTS,
  MCP_REQUESTABLE_SCOPES,
  MCP_SCOPES,
  MESSAGE_ROLE,
  MICROSOFT_CALENDAR_CONNECTION_STATUSES,
  MICROSOFT_CALENDAR_OAUTH_RESULTS,
  MICROSOFT_CALENDAR_OUTBOUND_STATUSES,
  MICROSOFT_CALENDAR_PUBLIC_STATUSES,
  NEWS_STATUS,
  OAUTH_LOGIN_METHODS,
  OUTLOOK_EVENT_AVAILABILITIES,
  OUTLOOK_EVENT_SENSITIVITIES,
  OnboardingPages,
  PERMISSIONS,
  RESOURCE_LIBRARY_ASSET_TYPE,
  RESOURCE_VISIBILITY,
  RICH_TEXT_RESOURCE_DISPLAY_MODE,
  RICH_TEXT_RESOURCE_TYPE,
  SCORM_COMPLETION_STATUS,
  SCORM_IMPORT_ACTION,
  SCORM_IMPORT_SOCKET,
  SCORM_PACKAGE_ENTITY_TYPE,
  SCORM_PACKAGE_STATUS,
  SCORM_STANDARD,
  SCORM_SUCCESS_STATUS,
  SESSION_REVOCATION_SOCKET,
  SHARE_IMAGE_HEIGHT,
  SHARE_IMAGE_WIDTH,
  STUDENT_COURSE_URGENCY,
  STUDENT_DASHBOARD_LIMITS,
  SUPPORTED_IMAGE_VARIANT_MIME_TYPES,
  SUPPORTED_LANGUAGES,
  SUPPORT_SESSION_STATUSES,
  SUPPORT_USER_SCOPES,
  SYSTEM_ROLE_PERMISSIONS,
  SYSTEM_ROLE_SLUGS,
  SYSTEM_RULE_SET_SLUGS,
  TENANT_STATUSES,
  USER_SOCKET_EVENTS,
  VIDEO_AUTOPLAY,
  VIDEO_EMBED_PROVIDERS,
  VIDEO_PROCESSING_STATUSES,
  VIDEO_PROVIDERS,
  VIDEO_UPLOAD_STATUS,
  VOICE_ACTION,
  VOICE_CAPTURE_PROFILE,
  VOICE_ENDPOINTING_MODE,
  VOICE_MODE_STATE,
  VOICE_SOCKET_EVENT,
  bucketizeVideoCoverageTimeRange,
  buildCertificateHtmlDocument,
  buildCertificateMarkup,
  classifyRichTextResourceType,
  countVideoCoverageRangeUnits,
  createTextUiMessage,
  defaultCertificateRenderTheme,
  deleteAutomationStep,
  deriveAutomationBranchFieldValues,
  detectVideoProviderFromUrl,
  duplicateAutomationWorkflow,
  evaluateAutomationWorkflow,
  extractResourceIdFromSourceUrl,
  extractVideoIdFromSourceUrl,
  extractVimeoId,
  extractYoutubeId,
  flattenAutomationWorkflow,
  getAncestorConditionOutcomes,
  getAutomationTriggerDefinition,
  getAutomationWorkflowIssues,
  getCanonicalAutomationField,
  getCourseChatRoom,
  getEmailCardBackground,
  getEmailTemplateLayoutSections,
  getUiMessageText,
  getVideoCoverageMaxBucketCount,
  hasAllPermissions,
  hasAnyPermission,
  hasPermission,
  insertAutomationStep,
  isAutomationFieldAvailable,
  isCourseFeatureEnabledForCourseType,
  isSupportedLanguage,
  isVideoCoverageRange,
  matchesRequirement,
  mergeVideoCoverageRanges,
  normalizeAuthoringQuizQuestionOrder,
  orderCourseAuthoringOperations,
  parseVideoCoverageRanges,
  planCourseAuthoringOrder,
  reparentAutomationStep,
  resolveAutomationEventFieldSourceKey,
  sanitizeQuizQuestionTitle,
  sanitizeRichTextSummary,
  toUiMessageRole,
  toVideoCoverageBucketRanges,
  tryParseUrl
};
